import React, { useCallback, useState, useEffect  } from "react";
import { useNavigate } from "react-router-dom";
import { db, auth } from "./firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { setDoc, doc,  getDocs, updateDoc } from "firebase/firestore";
import { collection,  addDoc, Timestamp, serverTimestamp} from "firebase/firestore";
import { getStorage, listAll, getDownloadURL } from "firebase/storage";
import { ref, uploadBytes,  uploadBytesResumable } from 'firebase/storage'; // Modular imports
import { deleteDoc } from "firebase/firestore";
import { storage } from './firebase'; // Import storage from firebase.js
import { v4 as uuidv4 } from "uuid"; // Import uuid for generating unique IDs
import { query, where} from "firebase/firestore";
import * as XLSX from 'xlsx';  // Import the XLSX library





import "./adminpanel.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Eye, EyeOff, Option } from "lucide-react";

const CreateStudentDashboard = () => {

  const [selectedOption, setSelectedOption] = useState("home"); // Default to "home"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [program, setProgram] = useState("");
  const [courseType, setCourseType] = useState("");
  const [courseFee, setCourseFee] = useState("");
  const [batch, setBatch] = useState("");
  const [address, setAddress] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fullName, setFullName] = useState("");
  const [nameWithInitial, setNameWithInitial] = useState("");
  const [nicPassport, setNicPassport] = useState("");
  const [contactNo, setContactNo] = useState("")
  const [nameToBeAppeared, setNameToBeAppeared] = useState("")


//edit student
const [editingUser, setEditingUser] = useState(null); // To hold the selected user's data for editing


  const [assignments, setAssignments] = useState([]); // For storing fetched assignments

//google classroom link
const [googleclassroomLink, setGoogleClassroomLink] = useState("")



  // Dropdown button for upload and update results
  const [isUserDropdownOpen, setUserDropdownOpen] = useState(false);
  const toggleUserDropdown = () => {
    setUserDropdownOpen(!isUserDropdownOpen);
  };



  // Dropdown button for upload and update results
  const [isResultDropdownOpen, setResultDropdownOpen] = useState(false);
  const toggleResultDropdown = () => {
    setResultDropdownOpen(!isResultDropdownOpen);
  };



  //quiz master link create
  const [quizLink, setQuizLink] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [Test, setTest] = useState("");


  //lecture video recordings
  const [lectureRecordingLink, setLectureRecordingLink] = useState("")
  const [session,  setSession] = useState("")
 
    // State variables for form inputs for upload assignment brief
    const [issueDate, setIssueDate] = useState('');  // Define issueDate state
    const [submissionDate, setSubmissionDate] = useState('');  // Define submissionDate state
   

//pdf upload
const [selectedFile, setSelectedFile] = useState(null);



  const [users, setUsers] = useState([]); // State to store users
  const [groupedUsers, setGroupedUsers] = useState({}); // Users grouped by role


// assignment deadline link
const [submissionDeadline, setSubmissionDeadline] = useState("");
const [uploadLink, setUploadLink] = useState("");

//assignment brief upload only three times
const [uploadProgress, setUploadProgress] = useState(0);

//upload pdf
const [file, setFile] = useState(null);
const [id, setId] = useState('');


   // Error state initialization
  const [error, setError] = useState(null);  // Initialize the error state
  const [loading, setLoading] = useState(false);
  

//notice board
  const [subject, setSubject] = useState("");
  const [notice, setNotice] = useState("");
  const [addedDate, setAddedDate] = useState("");

//input course module
const [success, setSuccess] = useState(null);

const navigate = useNavigate();



//upload result
const [semester, setSemester] = useState('');
const [typeOfAssesment, setTypeOfAssesment] = useState('');
const [moduleCode, setModuleCode] = useState('');
const [moduleName, setModuleName] = useState('');
const [grade, setGrade] = useState('');


//PASSWORD VIEW
const [showPassword, setShowPassword] = useState(false);


//sarch user by name & batch
const [filteredUsers, setFilteredUsers] = useState([]);
const [searchQuery, setSearchQuery] = useState("");
const [searchOption, setSearchOption] = useState("name");


//student payment details tab
const [students, setStudents] = useState([]);
const [filteredStudents, setFilteredStudents] = useState([]);


//calculate total outstanding amount according to the batch & course
// State for dropdowns and data
const [outstandingPayments, setOutstandingPayments] = useState(0);

const [isSubmitted, setIsSubmitted] = useState(false); // To track if submit is clicked




//upload image in notice board
// Add these state variables at the top of your component
const [hasImage, setHasImage] = useState(false);
const [imageFile, setImageFile] = useState(null);
const [imageUrl, setImageUrl] = useState('');
const [isUploading, setIsUploading] = useState(false);



  // Logout function
  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };


  const createAccount = async () => {
    try {
      // Create user in Firebase Authentication
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;


      // Save user details in Firestore
      await setDoc(doc(db, "users", userId), {
        email,
        role,
        registrationNumber,
        program,
        courseType,
        courseFee,
        batch,
        address,
        firstName,
        lastName,
        fullName,
        nameWithInitial,
        nicPassport,
        contactNo,
        nameToBeAppeared,
      });



      alert("User created successfully!");
      // Reset the form
      setEmail("");
      setPassword("");
      setRole("");
      setRegistrationNumber("");
      setProgram("");
      setCourseType("");
      setCourseFee("");
      setBatch("");
      setAddress("");
      setFirstName("");
      setLastName("");
      setFullName("");
      setNameWithInitial("");
      setNicPassport("");
      setContactNo("");
      setNameToBeAppeared("");

    } catch (error) {
      console.error("Error creating user:", error.message);
      alert(error.message);
    }
  };




//create course module
  const [moduleData, setModuleData] = useState({
    id: "",
    moduleCode: "",
    moduleName: "",
    semester: "",
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setModuleData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
  
    // Validate if all required fields are filled
    if (
      !moduleData.semester ||
      !moduleData.moduleCode ||
      !moduleData.moduleName ||
      !moduleData.id
    ) {
      setError("Please fill all the fields.");
      setLoading(false);
      return;
    }
  
    try {
      // Add the module to Firestore
      const modulesRef = collection(db, "cmodule");
      await addDoc(modulesRef, moduleData);
      toast.success("✅ Module created successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
  
      // Reset form fields
      setModuleData({
        id: "",
        moduleCode: "",
        moduleName: "",
        semester: "",
      });
    } catch (err) {
      console.error("Error creating module:", err);
      setError("Failed to create module: " + err.message);
      toast.error("❌ Failed to create module: " + err.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };










// Fetch all users to view from Firestore based on role
useEffect(() => {
  if (selectedOption === "viewAllUsers") {
    fetchAllUsers();
  }
}, [selectedOption]);

// // Fetch all users from Firestore
// const fetchAllUsers = async () => {
//   try {
//     const querySnapshot = await getDocs(collection(db, "users"));
//     const userList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

//     // Group users by role
//     const grouped = userList.reduce((acc, user) => {
//       if (!acc[user.role]) acc[user.role] = [];
//       acc[user.role].push(user);
//       return acc;
//     }, {});

//     setUsers(userList);
//     setGroupedUsers(grouped);
//   } catch (error) {
//     console.error("Error fetching users:", error.message);
//     alert("Failed to fetch users.");
//   }
// };

const renderUsersByrole = () => {
  return Object.keys(groupedUsers).map((role) => (
    <div key={role} className="user-group">
      <h2 className="role-title">{role.charAt(0).toUpperCase() + role.slice(1)}s</h2>
      <table className="user-table">
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Email</th>
            <th>Contact Number</th>
            <th>Program</th>
            <th>Registration Number</th>
          </tr>
        </thead>
        <tbody>
          {groupedUsers[role].map((user) => (
            <tr key={user.id}>
              <td>{user.fullName}</td>
              <td>{user.email}</td>
              <td>{user.contactNo}</td>
              <td>{user.program}</td>
              <td>{user.registrationNumber}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ));
};
  
















//Fetch users from Firestore when "Manage Users" is selected
useEffect(() => {
  if (selectedOption === "manageUsers") {
    fetchUsers();
  }
}, [selectedOption]);

const fetchUsers = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "users"));
    const usersData = querySnapshot.docs.map((doc) => ({
      id: doc.id, // User ID
      ...doc.data(), // User data
    }));

    setUsers(usersData);

    // Group users by role for better display
    const grouped = usersData.reduce((acc, user) => {
      if (!acc[user.role]) acc[user.role] = [];
      acc[user.role].push(user);
      return acc;
    }, {});
    setGroupedUsers(grouped);
  } catch (error) {
    console.error("Error fetching users:", error.message);
  }
};

// Remove a user by ID
const removeUser = async (userId) => {
  try {
    // Use deleteDoc to delete the document
    await deleteDoc(doc(db, "users", userId)); 
    alert("User removed successfully!");

    // Update the users state by removing the deleted user
    setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));
  } catch (error) {
    console.error("Error removing user:", error.message);
    alert("Failed to remove user. Please try again.");
  }
};

// Render users grouped by role
const renderUsersByRole = () => {
  return Object.entries(groupedUsers).map(([role, users]) => (
    <div key={role} className="user-role-group">
      <h2>{role.charAt(0).toUpperCase() + role.slice(1)}</h2>
      <ul>
        {users.map((user) => (
          <li key={user.id} className="user-item">
            <span>{user.fullName} ({user.email})</span>
            <button
              className="remove-user-button"
              onClick={() => removeUser(user.id)}
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
    </div>
  ));
};







//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


////create notices
// const createNotice = async () => {
//   if (!subject || !notice || !addedDate) {
//     toast.error("❌ All fields are required!", {
//       position: "top-right",
//       autoClose: 3000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       theme: "colored",
//     });
//     return;
//   }

//   try {
//     await addDoc(collection(db, "notices"), {
//       subject: subject,
//       notice: notice,
//       addedDate: Timestamp.fromDate(new Date(addedDate)), // Convert to Firestore Timestamp
//     });

//     toast.success("✅ Notice created successfully!", {
//       position: "top-right",
//       autoClose: 3000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       theme: "colored",
//     });

//     // Clear input fields after success
//     setSubject("");
//     setNotice("");
//     setAddedDate("");
//   } catch (error) {
//     console.error("Error adding notice: ", error);
//     toast.error("❌ Failed to create notice. Please try again.", {
//       position: "top-right",
//       autoClose: 3000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       theme: "colored",
//     });
//   }
// };

// Update your createNotice function
const createNotice = async () => {
  if (!subject || !notice || !addedDate) {
    toast.error("❌ All fields are required!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
    return;
  }

  setIsUploading(true);

  try {
    const noticeData = {
      subject: subject,
      notice: notice,
      addedDate: Timestamp.fromDate(new Date(addedDate)),
      hasImage: hasImage,
    };

    // If image is included, upload it first
    if (hasImage && imageFile) {
      const storageRef = ref(storage, `notices/${Date.now()}_${imageFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, imageFile);
      
      // Wait for upload to complete
      await uploadTask;
      
      // Get download URL
      const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
      noticeData.imageUrl = downloadURL;
    }

    // Save notice to Firestore
    await addDoc(collection(db, "notices"), noticeData);

    toast.success("✅ Notice created successfully!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });

    // Clear all fields after success
    setSubject("");
    setNotice("");
    setAddedDate("");
    setHasImage(false);
    setImageFile(null);
    setImageUrl("");
  } catch (error) {
    console.error("Error adding notice: ", error);
    toast.error("❌ Failed to create notice. Please try again.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  } finally {
    setIsUploading(false);
  }
};




/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//upload results
const [remark, setRemark] = useState("");
const [date, setDate] = useState("");
const [attemptNo, setAttemptNo] = useState("1st"); // Default to "1st" if not provided


const uploadResults = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const resultsCollection = collection(db, "results");
    await addDoc(resultsCollection, {
      semester,
      date,
      attemptNo: attemptNo || "1st", // Default to "1st" if not provided
      typeOfAssesment,
      registrationNumber,
      program,
      batch,
      moduleCode,
      moduleName,
      grade,
      remark,
    });

    toast.success("✅ Result uploaded successfully!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });

    // Reset form fields
    setSemester("");
    setDate("");
    setAttemptNo("1st"); // Reset attempt number to 1
    setTypeOfAssesment("");
    setRegistrationNumber("");
    setProgram("");
    setBatch("");
    setModuleCode("");
    setModuleName("");
    setGrade("");
    setRemark("");

  } catch (error) {
    console.error("Error uploading result:", error);
    toast.error("❌ Failed to upload the result. Please try again.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  } finally {
    setLoading(false);
  }
};





//upload pdf
  // Handle file selection
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedFile(file);
      setError('');
    } else {
      setError("Please select a valid PDF file.");
    }
  };

  // Handle form submission and file upload
  const uploadFile = async (e) => {
    e.preventDefault();

    if (!selectedFile) {
      setError("No file selected.");
      return;
    }

    if (!batch || !id || !moduleCode || !moduleName) {
      setError("Please fill in all the fields.");
      return;
    }

    setLoading(true);

    try {
      // Generate a unique file name using UUID
      const uniqueFileName = `${uuidv4()}_${selectedFile.name}`;

      // Upload the file to Firebase Storage with a unique file name
      const storageRef = ref(storage, `pdfs/${uniqueFileName}`);
      await uploadBytes(storageRef, selectedFile);

      // Get the download URL
      const fileUrl = await getDownloadURL(storageRef);
      console.log("File uploaded successfully:", fileUrl);

      // Optionally, store the file URL and other data in Firestore
      // Store multiple PDFs under the same 'id' using addDoc to create a new document each time
      await addDoc(collection(db, "materials"), {
        batch,
        id,
        moduleCode,
        moduleName,
        fileUrl,
      });

      setLoading(false);
      alert("File uploaded successfully!");
    } catch (err) {
      console.error("Upload error:", err);
      setError(`Error uploading file: ${err.message || err}`);
      setLoading(false);
    }
  };








//upload assignment  brief
// Handle form submission and file upload
const uploadAssignmnt = async (e) => {
  e.preventDefault();

  if (!selectedFile) {
    setError("No file selected.");
    return;
  }

  if (!batch || !id || !moduleCode || !moduleName || !issueDate || !submissionDate) {
    setError("Please fill in all the fields.");
    return;
  }

  if (new Date(issueDate) > new Date(submissionDate)) {
    setError("Issue Date cannot be later than Submission Date.");
    return;
  }

  setLoading(true);
  setUploadProgress(0);

  try {
    const fileName = `${selectedFile.name}-${new Date().getTime()}`;
    const storageRef = ref(storage, `pdfs/${fileName}`);
    const uploadTask = uploadBytesResumable(storageRef, selectedFile);

    // Track progress
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress);
      },
      (error) => {
        console.error("Error uploading file:", error);
        setError("Failed to upload file.");
        setLoading(false);
      },
      async () => {
        const fileUrl = await getDownloadURL(uploadTask.snapshot.ref);
        console.log("Assignment uploaded successfully:", fileUrl);

        const assignmentDocRef = doc(db, "assignments", `${id}-${new Date().getTime()}`);

        await setDoc(assignmentDocRef, {
          batch,
          id,
          moduleCode,
          moduleName,
          issueDate,
          submissionDate,
          fileUrl,
        });

        setLoading(false);
        setUploadProgress(0);
        alert("Assignment uploaded successfully!");

        // Clear form fields
        setBatch("");
        setId("");
        setModuleCode("");
        setModuleName("");
        setIssueDate("");
        setSubmissionDate("");
        setSelectedFile(null);
      }
    );
  } catch (err) {
    console.error("Upload error:", err);
    setError(`Error uploading file: ${err.message || err}`);
    setLoading(false);
    setUploadProgress(0);
  }
};

const handleAssignmentChange = (e) => {
  const file = e.target.files[0];
  if (file && file.type === "application/pdf") {
    setSelectedFile(file); // Ensure `setSelectedFile` is defined in your state
    setError(""); // Optional: Clear any previous errors
  } else {
    setError("Please select a valid PDF file.");
  }
};









//update student payments
const [formData, setFormData] = useState({
  registrationNumber: "",
  paymentDate: "",
  receiptNo: "",
  paymentType: "",
  amount: "",
  remark: "",
});


// Handle input changes
const paymentChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
};

// Handle form submission
const paymentSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setSuccess("");

  try {
    await addDoc(collection(db, "payments"), {
      ...formData,
      paymentDate: formData.paymentDate ? new Date(formData.paymentDate) : serverTimestamp(), // Use selected payment date, or fallback to server timestamp
      amount: parseInt(formData.amount), // Ensure amount is a number
    });
    setSuccess("Payment data submitted successfully!");
    setFormData({
      registrationNumber: "",
      paymentDate: "",
      receiptNo: "",
      paymentType: "",
      amount: "",
      remark: "",
    });
  } catch (err) {
    setError("Error submitting data: " + err.message);
  }
};











// //create assignment deadline link
const handleCreateAssignment = async () => {
  if (!moduleName || !moduleCode || !submissionDeadline || !batch || !id) {
    alert("All fields are required!");
    return;
  }

  try {
    setLoading(true);

    // Convert submissionDeadline to a timestamp
    const deadlineTimestamp = new Date(submissionDeadline).getTime();

    // Generate the upload link
    const uploadLink = `assignments/${id}_${batch}_${deadlineTimestamp}`;

    // Add the assignment details to the Firestore collection
    await addDoc(collection(db, "assignmentSubmissionDetails"), {
      id,
      batch,
      moduleName,
      moduleCode,
      submissionDeadline: new Date(submissionDeadline),
      uploadLink, // Include the generated upload link
    });

    alert("Assignment deadline created successfully!");
    
    // Clear form fields after successful creation
    setBatch("");
    setId("");
    setModuleName("");
    setModuleCode("");
    setSubmissionDeadline("");

  } catch (error) {
    console.error("Error creating assignment:", error);
    alert("Failed to create assignment. Try again.");
  } finally {
    setLoading(false);
  }
};




//create assignment deadline link for mitigate student//////////////////////////////////////////////////////////////////////////////////
// //create assignment deadline link
const handleCreateAssignmentForMitigate = async () => {
  if (!moduleName || !moduleCode || !submissionDeadline || !batch || !id) {
    alert("All fields are required!");
    return;
  }

  try {
    setLoading(true);

    // Convert submissionDeadline to a timestamp
    const deadlineTimestamp = new Date(submissionDeadline).getTime();

    // Generate the upload link
    const uploadLink = `assignments/${id}_${batch}_${deadlineTimestamp}`;

    // Add the assignment details to the Firestore collection
    await addDoc(collection(db, "assignmentSubmissionDetails"), {
      id,
      registrationNumber,
      batch,
      moduleName,
      moduleCode,
      submissionDeadline: new Date(submissionDeadline),
      uploadLink, // Include the generated upload link
    });

    alert("Assignment deadline created successfully!");
    
    // Clear form fields after successful creation
    setBatch("");
    setId("");
    setModuleName("");
    setModuleCode("");
    setSubmissionDeadline("");

  } catch (error) {
    console.error("Error creating assignment:", error);
    alert("Failed to create assignment. Try again.");
  } finally {
    setLoading(false);
  }
};










 // Fetch all users when the option is selected
//  useEffect(() => {
//   if (selectedOption === "viewAllUsers") {
//     fetchAllUsers();
//   }
// }, [selectedOption]);

// // Fetch all users from Firestore
// const fetchAllUsers = async () => {
//   try {
//     const querySnapshot = await getDocs(collection(db, "users"));
//     const userList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

//     // Group users by role
//     const grouped = userList.reduce((acc, user) => {
//       if (!acc[user.role]) acc[user.role] = [];
//       acc[user.role].push(user);
//       return acc;
//     }, {});

//     setUsers(userList);
//     setFilteredUsers(userList); // Initialize filtered users
//     setGroupedUsers(grouped);
//   } catch (error) {
//     console.error("Error fetching users:", error.message);
//     alert("Failed to fetch users.");
//   }
// };



// Fetch all users when the option is selected
useEffect(() => {
  if (selectedOption === "viewAllUsers") {
    fetchAllUsers();
  }
}, [selectedOption]);

// Fetch all users from Firestore
const fetchAllUsers = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "users"));
    const userList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    // Group users by role
    const grouped = userList.reduce((acc, user) => {
      if (!acc[user.role]) acc[user.role] = [];
      acc[user.role].push(user);
      return acc;
    }, {});

    setUsers(userList);
    setFilteredUsers(userList); // Initialize filtered users
    setGroupedUsers(grouped);
  } catch (error) {
    console.error("Error fetching users:", error.message);
    alert("Failed to fetch users.");
  }
};



// Function to download all user details as an Excel file (.xlsx)
const downloadUsers = () => {
  try {
    // Create a worksheet from the users array
    const ws = XLSX.utils.json_to_sheet(users);
    
    // Create a new workbook
    const wb = XLSX.utils.book_new();
    
    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Users');
    
    // Write the workbook to an Excel file and trigger the download
    XLSX.writeFile(wb, 'users.xlsx');
  } catch (error) {
    console.error('Error generating Excel file:', error);
    alert('Failed to generate Excel file.');
  }
};





// Search functionality
useEffect(() => {
  if (searchQuery.trim() === "") {
    setFilteredUsers(users);
  } else {
    const filtered = users.filter((user) => {
      if (searchOption === "name") {
        return user.fullName?.toLowerCase().includes(searchQuery.toLowerCase());
      } else if (searchOption === "registrationNumber") {
        return user.registrationNumber?.toLowerCase().includes(searchQuery.toLowerCase());
      }
      return false;
    });
    setFilteredUsers(filtered);
  }
}, [searchQuery, searchOption, users]);


// Render filtered users by role
const renderFilteredUsers = () => {
  const grouped = filteredUsers.reduce((acc, user) => {
    if (!acc[user.role]) acc[user.role] = [];
    acc[user.role].push(user);
    return acc;
  }, {});

  return Object.keys(grouped).map((role) => (
    <div key={role} className="user-group">
      <h2 className="role-title">{role.charAt(0).toUpperCase() + role.slice(1)}s</h2>
      <table className="user-table">
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Email</th>
            <th>Contact Number</th>
            <th>Program</th>
            <th>Course Type</th>
            <th>Registration Number</th>
            
          </tr>
        </thead>
        <tbody>
          {grouped[role].map((user) => (
            <tr key={user.id}>
              <td>{user.fullName}</td>
              <td>{user.email}</td>
              <td>{user.contactNo}</td>
              <td>{user.program}</td>
              <td>{user.courseType}</td>
              <td>{user.registrationNumber}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ));
};











// Function to fetch outstanding payments when submit is clicked
const fetchOutstandingPayments = async () => {
  try {
    if (!courseType || !batch) return; // Don't run if no selection

    // Determine prefix from course type
    const prefix = courseType === "Certificate in Optician" ? "CO-" : "DO-";

    // Fetch all users from the selected batch and course type
    const usersQuery = query(
      collection(db, "users"),
      where("registrationNumber", ">=", prefix), 
      where("registrationNumber", "<", prefix + "\uf8ff"),
      where("batch", "==", batch)
    );

    const usersSnapshot = await getDocs(usersQuery);
    if (usersSnapshot.empty) {
      setOutstandingPayments(0);
      return;
    }

    const registrationNumbers = usersSnapshot.docs.map((doc) => doc.data().registrationNumber);

    let totalOutstanding = 0;

    // Loop through each registration number to calculate outstanding
    for (const regNo of registrationNumbers) {
      // Fetch payments for this registration number
      const paymentsQuery = query(
        collection(db, "payments"),
        where("registrationNumber", "==", regNo)
      );

      const paymentsSnapshot = await getDocs(paymentsQuery);
      
      // Calculate total paid
      let totalPaid = 0;
      paymentsSnapshot.forEach((doc) => {
        const payment = doc.data();
        totalPaid += payment.amount;
      });

      // Fetch course fee from user document
      const userDoc = usersSnapshot.docs.find((doc) => doc.data().registrationNumber === regNo);
      const courseFee = userDoc?.data().courseFee || 0;

      // Calculate outstanding amount for this student
      const outstandingAmount = courseFee - totalPaid;
      totalOutstanding += outstandingAmount;
    }

    setOutstandingPayments(totalOutstanding);
  } catch (error) {
    console.error("Error fetching outstanding payments: ", error);
  }
};

const handlePaymentSubmit = () => {
  setIsSubmitted(true); // Mark the form as submitted
  fetchOutstandingPayments(); // Trigger fetching outstanding payments
};



const handleClear = () => {
  setCourseType(""); // Reset course type
  setBatch(""); // Reset batch
  setOutstandingPayments(0); // Reset outstanding payments
  setIsSubmitted(false); // Reset submission state
};





// Fetch all students with their payment details
// const fetchAllStudentsWithPayments = useCallback(async () => {
//   try {
//     // Fetch all students
//     const querySnapshot = await getDocs(collection(db, "users"));
//     const studentList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

//     const studentsWithPayments = await Promise.all(
//       studentList.map(async (student) => {
//         // Ensure registrationNumber exists before making the query
//         if (!student.registrationNumber) {
//           console.error(`Student ${student.id} does not have a registration number.`);
//           return null; // Skip this student
//         }

//         // Fetch payments for the student
//         const paymentQuery = query(
//           collection(db, "payments"),
//           where("registrationNumber", "==", student.registrationNumber)
//         );
//         const paymentSnapshot = await getDocs(paymentQuery);
//         let totalPaid = 0;
//         let paymentsList = [];

//         paymentSnapshot.forEach((doc) => {
//           const payment = doc.data();
//           paymentsList.push({ id: doc.id, ...payment });
//           totalPaid += payment.amount; // Sum up payment amounts
//         });

//         // Ensure courseFee exists for the student
//         const courseFee = student.courseFee || 0; // Default to 0 if missing
//         const outstandingAmount = courseFee - totalPaid;

//         return {
//           ...student,
//           payments: paymentsList,
//           totalPaid,
//           outstandingAmount,
//         };
//       })
//     );






//     // Filter out any null results (students without registration number)
//     const validStudents = studentsWithPayments.filter((student) => student !== null);
    
//     setStudents(validStudents);
//     setFilteredStudents(validStudents); // Initialize filtered students
//   } catch (error) {
//     console.error("Error fetching students with payments: ", error);
//   }
// }, []);

// useEffect(() => {
//   fetchAllStudentsWithPayments();
// }, [fetchAllStudentsWithPayments]);

// // Search functionality
// useEffect(() => {
//   if (searchQuery.trim() === "") {
//     setFilteredStudents(students);
//   } else {
//     const filtered = students.filter((student) => {
//       if (searchOption === "name") {
//         return student.fullName?.toLowerCase().includes(searchQuery.toLowerCase());
//       } else if (searchOption === "registrationNumber") {
//         return student.registrationNumber?.toLowerCase().includes(searchQuery.toLowerCase());
//       }
//       return false;
//     });
//     setFilteredStudents(filtered);
//   }
// }, [searchQuery, searchOption, students]);

// // Handle search input change
// const handleSearchChange = (e) => {
//   setSearchQuery(e.target.value);
// };

// // Handle search option change (by name or registration number)
// const handleSearchOptionChange = (e) => {
//   setSearchOption(e.target.value);
// };




// Fetch all students with their payment details
const fetchAllStudentsWithPayments = useCallback(async () => {
  try {
    // Fetch all students
    const querySnapshot = await getDocs(collection(db, "users"));
    const studentList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    const studentsWithPayments = await Promise.all(
      studentList.map(async (student) => {
        // Ensure registrationNumber exists before making the query
        if (!student.registrationNumber) {
          console.error(`Student ${student.id} does not have a registration number.`);
          return null; // Skip this student
        }

        // Fetch payments for the student
        const paymentQuery = query(
          collection(db, "payments"),
          where("registrationNumber", "==", student.registrationNumber)
        );
        const paymentSnapshot = await getDocs(paymentQuery);
        let totalPaid = 0;
        let paymentsList = [];

        paymentSnapshot.forEach((doc) => {
          const payment = doc.data();
          paymentsList.push({ id: doc.id, ...payment });
          totalPaid += payment.amount; // Sum up payment amounts
        });

        // Ensure courseFee exists for the student
        const courseFee = student.courseFee || 0; // Default to 0 if missing
        const outstandingAmount = courseFee - totalPaid;

        return {
          ...student,
          payments: paymentsList,
          totalPaid,
          outstandingAmount,
        };
      })
    );

    // Filter out any null results (students without registration number)
    const validStudents = studentsWithPayments.filter((student) => student !== null);
    
    setStudents(validStudents);
    setFilteredStudents(validStudents); // Initialize filtered students
  } catch (error) {
    console.error("Error fetching students with payments: ", error);
  }
}, []);

useEffect(() => {
  fetchAllStudentsWithPayments();
}, [fetchAllStudentsWithPayments]);

// Search functionality
useEffect(() => {
  if (searchQuery.trim() === "") {
    setFilteredStudents(students);
  } else {
    const filtered = students.filter((student) => {
      if (searchOption === "name") {
        return student.fullName?.toLowerCase().includes(searchQuery.toLowerCase());
      } else if (searchOption === "registrationNumber") {
        return student.registrationNumber?.toLowerCase().includes(searchQuery.toLowerCase());
      }
      return false;
    });
    setFilteredStudents(filtered);
  }
}, [searchQuery, searchOption, students]);

// Handle search input change
const handleSearchChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle search option change (by name or registration number)
const handleSearchOptionChange = (e) => {
  setSearchOption(e.target.value);
};





// Add this delete function near your other functions
const deletePayment = async (paymentId) => {
  if (!window.confirm("Are you sure you want to delete this payment?")) {
    return;
  }
  
  try {
    await deleteDoc(doc(db, "payments", paymentId));
    fetchAllStudentsWithPayments(); // Refresh the data
    alert("Payment deleted successfully");
  } catch (error) {
    console.error("Error deleting payment: ", error);
    alert("Failed to delete payment");
  }
};













//upload quiz master link
// Handle form submission
const uploadQuizLink = async (e) => {
  e.preventDefault();

  if (!courseType || !quizLink) {
    setErrorMessage("Please fill in both fields.");
    return;
  }

  try {
    // Saving the link and courseType to the Firestore collection "quizMaster"
    await addDoc(collection(db, "quizMaster"), {
      courseType,
      quizLink,
      moduleName,
      Test,
      createdAt: new Date(),
    });
    setSuccessMessage("Quiz Master link uploaded successfully!");
    setQuizLink(""); // Reset quiz link
    setCourseType(""); // Reset course type
    setModuleName("")
    setTest("")
  } catch (error) {
    setErrorMessage("Error uploading quiz link: " + error.message);
  }
};







//upload Recording Link
// Handle form submission
const uploadRecordingLink = async (e) => {
  e.preventDefault();

  if (!courseType || !lectureRecordingLink) {
    setErrorMessage("Please fill in both fields.");
    return;
  }

  try {
    // Saving the link and courseType to the Firestore collection "quizMaster"
    await addDoc(collection(db, "lectureRecordings"), {
      courseType,
      lectureRecordingLink,
      moduleName,
      session,
      createdAt: new Date(),
    });
    setSuccessMessage("Lecture Recording link uploaded successfully!");
    setLectureRecordingLink(""); // Reset quiz link
    setCourseType(""); // Reset course type
    setModuleName("")
    setTest("")
  } catch (error) {
    setErrorMessage("Error uploading quiz link: " + error.message);
  }
};





//upload google classroom link
// Handle form submission
const uploadGoogleClassroomLink = async (e) => {
  e.preventDefault();

  if (!courseType || !googleclassroomLink) {
    setErrorMessage("Please fill in both fields.");
    return;
  }

  try {
    // Saving the link and courseType to the Firestore collection "quizMaster"
    await addDoc(collection(db, "googleclassroom"), {
      courseType,
      googleclassroomLink,
      createdAt: new Date(),
    });
    setSuccessMessage("Google Classroom link uploaded successfully!");
    setGoogleClassroomLink(""); // Reset link
    setCourseType(""); // Reset course type
  } catch (error) {
    setErrorMessage("Error uploading quiz link: " + error.message);
  }
};






//edit / update students

// Fetch students with proper registration number handling
const fetchStudents = async () => {
  try {
    const usersCollection = collection(db, "users");
    const usersSnapshot = await getDocs(usersCollection);
    
    const usersList = usersSnapshot.docs.map(doc => {
      const data = doc.data();
      // Ensure registrationNumber exists, otherwise provide empty string
      const registrationNumber = data.registrationNumber ?? '';
      
      return {
        id: doc.id,
        ...data,
        registrationNumber // This will override any undefined registrationNumber
      };
    });

    console.log("Fetched students:", usersList);
    setStudents(usersList);
  } catch (error) {
    console.error("Error fetching students:", error);
    setStudents([]);
  }
};

// Enhanced handleEditUser with validation
const handleEditUser = (user) => {
  if (!user) return;
  
  // Ensure registrationNumber exists in the editing user
  const userWithRegistration = {
    ...user,
    registrationNumber: user.registrationNumber || ''
  };
  
  setEditingUser(userWithRegistration);
};

// Robust handleUpdateUser
const handleUpdateUser = async () => {
  try {
    if (!editingUser || !editingUser.id) {
      alert("Please select a valid student to edit");
      return;
    }

    // Create update object excluding the document ID
    const { id, ...updateData } = editingUser;
    
    // Ensure registrationNumber is not empty if required
    if (!updateData.registrationNumber?.trim()) {
      alert("Registration number cannot be empty");
      return;
    }

    await updateDoc(doc(db, "users", id), updateData);
    alert("Student updated successfully!");
    setEditingUser(null);
    fetchStudents();
  } catch (error) {
    console.error("Update error:", {
      error,
      editingUser,
      timestamp: new Date().toISOString()
    });
    alert(`Update failed: ${error.message}`);
  }
};

useEffect(() => {
  let isMounted = true;

  const loadData = async () => {
    try {
      await fetchStudents();
      
      if (isMounted) {
        console.log("Student data loaded successfully");
      }
    } catch (error) {
      if (isMounted) {
        console.error("Data loading error:", error);
      }
    }
  };

  loadData();

  return () => {
    isMounted = false;
  };
}, []);






// Filter students based on search term to edit students
// const [searchTerm, setSearchTerm] = useState("");

// useEffect(() => {
//   if (!searchTerm.trim()) {
//     setFilteredStudents(students);
//     return;
//   }

//   const lowerCaseSearch = searchTerm.toLowerCase();
//   const filtered = students.filter(student =>
//     student.fullName.toLowerCase().includes(lowerCaseSearch) ||
//     student.registrationNumber?.toLowerCase().includes(lowerCaseSearch)
//   );
//   setFilteredStudents(filtered);
// }, [searchTerm, students]);


  // Declare searchTerm state variable
  const [searchTerm, setSearchTerm] = useState("");

useEffect(() => {
  if (!searchTerm.trim()) {
    setFilteredStudents(students);
    return;
  }

  const lowerCaseSearch = searchTerm.toLowerCase();
  const filtered = students.filter(student => {
    const fullName = student.fullName || '';
    const regNumber = student.registrationNumber || '';
    
    return (
      fullName.toLowerCase().includes(lowerCaseSearch) ||
      regNumber.toLowerCase().includes(lowerCaseSearch)
    );
  });
  setFilteredStudents(filtered);
}, [searchTerm, students]);








// fetch all the assignments from firebase storage and firestore
// const [filteredAssignments, setFilteredAssignments] = useState([]);
// const [filters, setFilters] = useState({
//   batch: '',
//   moduleCode: ''
// });
// const [availableBatches, setAvailableBatches] = useState([]);
// const [availableModules, setAvailableModules] = useState([]);

// // Function to fetch assignment details from Firestore and the actual files from Firebase Storage
// const fetchAssignments = async () => {
//   setLoading(true);
//   try {
//     const querySnapshot = await getDocs(collection(db, "assignmentSubmissionDetails"));
//     const fetchedAssignments = [];
//     const batches = new Set();
//     const modules = new Set();



//     // Fetching assignment details from Firestore
//     for (const doc of querySnapshot.docs) {
//       const assignmentData = doc.data();
//       const moduleFolderRef = ref(getStorage(), `assignments/${assignmentData.moduleCode}`);
      
//       // Track unique batches and modules
//       batches.add(assignmentData.batch);
//       modules.add(assignmentData.moduleCode);

//       // Fetch files in the corresponding module folder in Storage
//       const filesSnapshot = await listAll(moduleFolderRef);
      
//       const fileLinks = await Promise.all(filesSnapshot.items.map(async (fileRef) => {
//         const fileUrl = await getDownloadURL(fileRef);
//         return { name: fileRef.name, url: fileUrl };
//       }));

//       fetchedAssignments.push({
//         ...assignmentData,
//         id: doc.id,
//         files: fileLinks,
//       });
//     }

//     setAssignments(fetchedAssignments);
//     setFilteredAssignments(fetchedAssignments);
//     setAvailableBatches(Array.from(batches));
//     setAvailableModules(Array.from(modules));
//   } catch (error) {
//     console.error("Error fetching assignments:", error);
//     alert("Failed to fetch assignments.");
//   } finally {
//     setLoading(false);
//   }
// };

// State management

const [studentSubmissions, setStudentSubmissions] = useState([]);
const [filteredData, setFilteredData] = useState([]);
const [filters, setFilters] = useState({
  batch: '',
  moduleCode: '',
  viewType: 'all' // 'all', 'assignments', or 'submissions'
});
const [availableBatches, setAvailableBatches] = useState([]);
const [availableModules, setAvailableModules] = useState([]);

// Fetch data from both collections
const fetchAllData = async () => {
  setLoading(true);
  try {
    // Fetch teacher assignments
    const assignmentsSnapshot = await getDocs(collection(db, "assignmentSubmissionDetails"));
    const fetchedAssignments = [];
    
    // Fetch student submissions
    const submissionsSnapshot = await getDocs(collection(db, "assignmentStudentDetails"));
    const fetchedSubmissions = [];
    
    const batches = new Set();
    const modules = new Set();

    // Process teacher assignments
    for (const doc of assignmentsSnapshot.docs) {
      const assignmentData = doc.data();
      batches.add(assignmentData.batch);
      modules.add(assignmentData.moduleCode);

      // Get files from Storage if needed
      const moduleFolderRef = ref(storage, `assignments/${assignmentData.moduleCode}`);
      const filesSnapshot = await listAll(moduleFolderRef);
      const fileLinks = await Promise.all(filesSnapshot.items.map(async (fileRef) => {
        const fileUrl = await getDownloadURL(fileRef);
        return { name: fileRef.name, url: fileUrl };
      }));

      fetchedAssignments.push({
        ...assignmentData,
        id: doc.id,
        type: 'assignment',
        files: fileLinks,
      });
    }

    // Process student submissions
    for (const doc of submissionsSnapshot.docs) {
      const submissionData = doc.data();
      batches.add(submissionData.batch);
      modules.add(submissionData.moduleCode);

      fetchedSubmissions.push({
        ...submissionData,
        id: doc.id,
        type: 'submission',
        files: submissionData.downloadURL ? [{
          name: submissionData.fileName,
          url: submissionData.downloadURL
        }] : []
      });
    }

    setAssignments(fetchedAssignments);
    setStudentSubmissions(fetchedSubmissions);
    setAvailableBatches(Array.from(batches));
    setAvailableModules(Array.from(modules));
    applyFilters(fetchedAssignments, fetchedSubmissions);

  } catch (error) {
    console.error("Error fetching data:", error);
    alert("Failed to fetch data.");
  } finally {
    setLoading(false);
  }
};








// Apply filters
// useEffect(() => {
//   let result = [...assignments];
  
//   if (filters.batch) {
//     result = result.filter(assignment => assignment.batch === filters.batch);
//   }
  
//   if (filters.moduleCode) {
//     result = result.filter(assignment => assignment.moduleCode === filters.moduleCode);
//   }
  
//   setFilteredAssignments(result);
// }, [filters, assignments]);

// const handleFilterChange = (e) => {
//   const { name, value } = e.target;
//   setFilters(prev => ({
//     ...prev,
//     [name]: value
//   }));
// };

// const resetFilters = () => {
//   setFilters({
//     batch: '',
//     moduleCode: ''
//   });
//   setFilteredAssignments(assignments);
// };

// useEffect(() => {
//   fetchAssignments();
// }, []);

// Apply filters to both datasets
const applyFilters = (assignmentsData = assignments, submissionsData = studentSubmissions) => {
  let filteredAssignments = [...assignmentsData];
  let filteredSubmissions = [...submissionsData];
  
  // Apply batch filter
  if (filters.batch) {
    filteredAssignments = filteredAssignments.filter(item => item.batch === filters.batch);
    filteredSubmissions = filteredSubmissions.filter(item => item.batch === filters.batch);
  }
  
  // Apply module filter
  if (filters.moduleCode) {
    filteredAssignments = filteredAssignments.filter(item => item.moduleCode === filters.moduleCode);
    filteredSubmissions = filteredSubmissions.filter(item => item.moduleCode === filters.moduleCode);
  }
  
  // Combine based on view type
  let result = [];
  switch (filters.viewType) {
    case 'assignments':
      result = filteredAssignments;
      break;
    case 'submissions':
      result = filteredSubmissions;
      break;
    default:
      result = [...filteredAssignments, ...filteredSubmissions];
  }
  
  setFilteredData(result);
};

const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters(prev => ({
    ...prev,
    [name]: value
  }));
};

const resetFilters = () => {
  setFilters({
    batch: '',
    moduleCode: '',
    viewType: 'all'
  });
  setFilteredData([...assignments, ...studentSubmissions]);
};

useEffect(() => {
  fetchAllData();
}, []);

useEffect(() => {
  applyFilters();
}, [filters, assignments, studentSubmissions]);





















//upload placement assignments

const [selectedFileName, setSelectedFileName] = useState('');
const [noPlacement, setNoPlacement] = useState("");

// Add this missing function
const handleFilePlacementSelect = (e) => {
  const selectedFile = e.target.files[0];
  if (selectedFile && (
      selectedFile.type === 'application/pdf' || 
      selectedFile.name.endsWith('.docx') ||
      selectedFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  )) {
    setFile(selectedFile);
    setSelectedFileName(selectedFile.name);
    setError('');
  } else {
    setFile(null);
    setSelectedFileName('');
    setError('Please select a valid PDF or DOCX file');
  }
};

const uploadPlacementFile = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');
  setSuccess('');

  if (!auth.currentUser) {
    setError('You must be logged in to upload files');
    setLoading(false);
    return;
  }

  if (!batch || !id || !noPlacement || !file) {
    setError('Please fill all fields and select a file');
    setLoading(false);
    return;
  }

  try {
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const fileName = `${batch}_${id}_${Date.now()}.${fileExtension}`;
    const storageRef = ref(storage, `placements/${fileName}`);

    const uploadTask = uploadBytesResumable(storageRef, file, {
      customMetadata: {
        uploadedBy: auth.currentUser.uid,
        batch: batch,
        course: id,
        noofPlacement: noPlacement,
        contentType: file.type
      }
    });

    uploadTask.on('state_changed', 
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload progress: ' + progress + '%');
      },
      (error) => {
        throw error;
      }
    );

    const snapshot = await uploadTask;
    const downloadURL = await getDownloadURL(snapshot.ref);

    await addDoc(collection(db, 'placements'), {
      batch,
      course: id,
       noofPlacement: noPlacement,
      fileName,
      fileUrl: downloadURL,
      uploadedBy: auth.currentUser.uid,
      uploaderEmail: auth.currentUser.email,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });

    setSuccess('Placement assignment uploaded successfully!');
    resetForm();

  } catch (err) {
    console.error('Upload error:', err);
    setError(`Upload failed: ${err.message}`);
  } finally {
    setLoading(false);
  }
};

const resetForm = () => {
  setBatch('');
  setId('');
  setNoPlacement('');
  setFile(null);
  setSelectedFileName('');
  const fileInput = document.getElementById('file-upload');
  if (fileInput) fileInput.value = '';
};
















  const [nameFilter, setNameFilter] = useState('');
  const [regNoFilter, setRegNoFilter] = useState('');
  const [moduleCodeFilter, setModuleCodeFilter] = useState('');
  const [moduleNameFilter, setModuleNameFilter] = useState('');
  
  // State for results data
  const [results, setResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  
  // State for editing
  const [editingResult, setEditingResult] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  // Fetch all results from Firestore
  useEffect(() => {
    const fetchResults = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'results'));
        const resultsData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setResults(resultsData);
        setFilteredResults(resultsData);
      } catch (error) {
        console.error('Error fetching results:', error);
      }
    };
    
    fetchResults();
  }, []);

  // Apply filters when any filter changes
  useEffect(() => {
    const filtered = results.filter(result => {
      const matchesName = nameFilter === '' || 
        (result.typeOfAssesment && result.typeOfAssesment.toLowerCase().includes(nameFilter.toLowerCase()));
      const matchesRegNo = regNoFilter === '' || 
        result.registrationNumber.includes(regNoFilter);
      const matchesModuleCode = moduleCodeFilter === '' || 
        result.moduleCode === moduleCodeFilter;
      const matchesModuleName = moduleNameFilter === '' || 
        result.moduleName === moduleNameFilter;
      
      return matchesName && matchesRegNo && matchesModuleCode && matchesModuleName;
    });
    
    setFilteredResults(filtered);
  }, [nameFilter, regNoFilter, moduleCodeFilter, moduleNameFilter, results]);

  // Start editing a result
  const handleEdit = (result) => {
    setEditingResult(result);
    setIsEditing(true);
  };

  // Handle input changes during editing
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditingResult(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Save edited result to Firestore
  const handleSave = async () => {
    try {
      await updateDoc(doc(db, 'results', editingResult.id), editingResult);
      // Update local state
      setResults(prev => prev.map(r => 
        r.id === editingResult.id ? editingResult : r
      ));
      setIsEditing(false);
      setEditingResult(null);
    } catch (error) {
      console.error('Error updating result:', error);
    }
  };

  // Cancel editing
  const handleCancel = () => {
    setIsEditing(false);
    setEditingResult(null);
  };

  // Get unique module codes for filter dropdown
  const uniqueModuleCodes = [...new Set(results.map(r => r.moduleCode))];
  // Get unique module names for filter dropdown
  const uniqueModuleNames = [...new Set(results.map(r => r.moduleName))];




  return (
    <div className="admin-container">

         {/* <div className="sun-overlay">
            <div className="sun-container">
              <img src="/vesak.png" alt="Sun with New Year" className="sun" />
            </div>
          </div>

          <div className="sun-overlay">
            <div className="sun-container">
              <img src="/vesak.png" alt="Sun with New Year" className="sun" />
            </div>
          </div> */}



          
      {/* Left-side panel */}
      <div className="admin-sidebar">
        <h2 className="admin-sidebar-title">Sub - Admin Panel</h2>
        <ul className="admin-sidebar-list">
          <li onClick={() => setSelectedOption("home")}>Home</li>
          <li onClick={() => setSelectedOption("createAccount")}>Create Users Account</li>


          
          {/* <li onClick={() => setSelectedOption("manageUsers")}>View All Users</li>
          <li onClick={() => setSelectedOption("editUser")}>Edit All Users</li>
          <li onClick={() => setSelectedOption("viewAllUsers")}>Manage Users</li> */}

           <li onClick={toggleUserDropdown} style={{ cursor: "pointer" }}>
              User Management {isUserDropdownOpen ? "▼" : "▶"}
          </li>
          
            {isUserDropdownOpen && (
              <ul style={{ paddingLeft: "20px" }}>
          <li onClick={() => setSelectedOption("manageUsers")}>View All Users</li>
          <li onClick={() => setSelectedOption("editUser")}>Edit All Users</li>
          {/* <li onClick={() => setSelectedOption("viewAllUsers")}>Manage Users</li> */}
          </ul>
          )} 



          {/* <li onClick={() => setSelectedOption("paymentDetails")}>Student Payment Details</li>
          <li onClick={() => setSelectedOption("createNotices")}>Create Notices</li>
          <li onClick={() => setSelectedOption("createModulesForCourses")}>Create Courses Modules</li>
          <li onClick={() => setSelectedOption("uploadAssignmentBrief")}>Upload Assignment Brief</li>
           <li onClick={() => setSelectedOption("uploadPlacement")}>Upload Placement Assignment</li>
          <li onClick={() => setSelectedOption("createAssignmentDeadline")}>Create Assignment Deadline Link</li>
          <li onClick={() => setSelectedOption("mitigatetDeadline")}>Assignment Deadline Link - Mitigate</li>
          <li onClick={() => setSelectedOption("viewAssignment")}>View All Submitted Assignments</li>
          <li onClick={() => setSelectedOption("updatePayments")}>Update Student Payments</li>
          <li onClick={() => setSelectedOption("outstandingPayments")}>Outstanding Payments</li>
          <li onClick={() => setSelectedOption("uploadMaterial")}>Upload Lecture Materials</li>
          <li onClick={() => setSelectedOption("uploadLectureRecordingLink")}>Upload Previous Lecture Recordings</li>
          <li onClick={() => setSelectedOption("uploadStudyMaterialLink")}>Upload Study Material Link</li>
          <li onClick={() => setSelectedOption("uploadQuizMasterLink")}>Upload Quiz Master Link</li> */}
          {/* <li onClick={() => setSelectedOption("uploadResults")}>Upload Results</li>
          <li onClick={() => setSelectedOption("updateResults")}>Update Results</li> */}


{/* 
                     <li onClick={toggleResultDropdown} style={{ cursor: "pointer" }}>
              Result Management {isResultDropdownOpen ? "▼" : "▶"}
          </li>

            {isResultDropdownOpen && (
              <ul style={{ paddingLeft: "20px" }}>
          <li onClick={() => setSelectedOption("uploadResults")}>Upload Results</li>
          <li onClick={() => setSelectedOption("updateResults")}>Update Results</li>
          </ul>
          )}  */}
          
          <li className="logout-button" onClick={handleLogout}>Logout</li>












        </ul>
      </div>

       {/* Main Panel */}
       <div className="admin-panel">
        {selectedOption === "home" && (
          <div className="home-section">
            <div className="home-content">
              <img
                src="/logo.jpg" // Assuming the image is in the public folder
                alt="Eye Care Institute"
                className="home-image"
              />
              <p className="home-description">
             We are a leading non-state higher education institute, approved by the Ministry of Education and accredited 
             by the Tertiary & Vocational Education Commission (TVEC). Additionally, we are members of the World Council of Optometry (WCO) 
             and the Asia Pacific Council of Optometry (APCO). Our Optician and Optometry courses are recognized by the Ceylon Council of
             Optometrists & Orthoptists (CCOO), Sri Lanka. ECI is the first Sri Lankan private institute to be recognized by the 
             Government of Sri Lanka. We are the only Optometry institute affiliated with a university.
              </p>
            </div>

            <div className="vision-mission">
              <div className="vision">
                <h2>Our Vision</h2>
                <p>
                  To be the leader in professional eye care organization by improving the quality and 
                  quantity of the service providers in all eye care segments in the region.
                </p>
              </div>

              <div className="mission">
                <h2>Our Mission</h2>
                <p>
                  Improve the quality of life in the region by integrating, sharing, and enhancing experience and 
                  innovation with professionals involved in eye care.
                </p>
              </div>
            </div>
          </div>
        )}





{selectedOption === "updateResults" && (
    <div className="result-update-container">
      <h1 className="result-update-title">Student Results Management</h1>
      
      {/* Filter Section */}
      <div className="result-update-filters">
        <h2 className="result-update-filters-title">Filters</h2>
        <div className="result-update-filter-row">
          <div className="result-update-filter-group">
            <label className="result-update-filter-label">Assesment Type:</label>
            <input 
              className="result-update-filter-input"
              type="text" 
              value={nameFilter}
              onChange={(e) => setNameFilter(e.target.value)}
              placeholder="Filter by Assesment type"
            />
          </div>
          
          <div className="result-update-filter-group">
            <label className="result-update-filter-label">Registration No:</label>
            <input 
              className="result-update-filter-input"
              type="text" 
              value={regNoFilter}
              onChange={(e) => setRegNoFilter(e.target.value)}
              placeholder="Filter by registration number"
            />
          </div>
        
          <div className="result-update-filter-group">
            <label className="result-update-filter-label">Module Code:</label>
            <select
              className="result-update-filter-select"
              value={moduleCodeFilter}
              onChange={(e) => setModuleCodeFilter(e.target.value)}
            >
              <option value="">All Module Codes</option>
              {uniqueModuleCodes.map(code => (
                <option key={code} value={code}>{code}</option>
              ))}
            </select>
          </div>
          
          <div className="result-update-filter-group">
            <label className="result-update-filter-label">Module Name:</label>
            <select
              className="result-update-filter-select"
              value={moduleNameFilter}
              onChange={(e) => setModuleNameFilter(e.target.value)}
            >
              <option value="">All Module Names</option>
              {uniqueModuleNames.map(name => (
                <option key={name} value={name}>{name}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
      
      {/* Loading State */}
      {loading ? (
        <div className="result-update-loading">Loading results...</div>
      ) : (
        /* Results Table */
        <div className="result-update-table-container">
          <table className="result-update-table">
            <thead className="result-update-table-head">
              <tr className="result-update-table-row">
                <th className="result-update-table-header">Assesment Type</th>
                <th className="result-update-table-header">Reg No</th>
                <th className="result-update-table-header">Module Code</th>
                <th className="result-update-table-header">Module Name</th>
                <th className="result-update-table-header">Grade</th>
                <th className="result-update-table-header">Remark</th>
                <th className="result-update-table-header">Actions</th>
              </tr>
            </thead>
            <tbody className="result-update-table-body">
              {filteredResults.length > 0 ? (
                filteredResults.map(result => (
                  <tr key={result.id} className="result-update-table-row">
                    <td className="result-update-table-data">{result.typeOfAssesment || 'N/A'}</td>
                    <td className="result-update-table-data">{result.registrationNumber}</td>
                    <td className="result-update-table-data">{result.moduleCode}</td>
                    <td className="result-update-table-data">{result.moduleName}</td>
                    <td className="result-update-table-data">{result.grade}</td>
                    <td className="result-update-table-data">{result.remark}</td>
                    <td className="result-update-table-data">
                      <button 
                        className="result-update-edit-btn"
                        onClick={() => handleEdit(result)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="result-update-table-row">
                  <td colSpan="7" className="result-update-no-results">
                    {results.length === 0 ? 'No results found' : 'No results match your filters'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      
      {/* Edit Modal */}
      {isEditing && editingResult && (
        <div className="result-update-modal">
          <div className="result-update-modal-content">
            <h2 className="result-update-modal-title">Edit Result</h2>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Registration Number:</label>
              <input 
                className="result-update-form-input"
                type="text" 
                name="registrationNumber"
                value={editingResult.registrationNumber || ''}
                onChange={handleEditChange}
                disabled
              />
            </div>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Module Code:</label>
              <input 
                className="result-update-form-input"
                type="text" 
                name="moduleCode"
                value={editingResult.moduleCode || ''}
                onChange={handleEditChange}
                required
              />
            </div>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Module Name:</label>
              <input 
                className="result-update-form-input"
                type="text" 
                name="moduleName"
                value={editingResult.moduleName || ''}
                onChange={handleEditChange}
                required
              />
            </div>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Grade:</label>
              <select
                className="result-update-form-select"
                name="grade"
                value={editingResult.grade || ''}
                onChange={handleEditChange}
                required
              >
                <option value="">Select Grade</option>
                <option value="A+">A+</option>
                <option value="A">A</option>
                <option value="B+">B+</option>
                <option value="B">B</option>
                <option value="C">C</option>
                <option value="-">-</option>
                <option value="F">F</option>
                <option value="AB">AB</option>
                <option value="N/A">N/A</option>
              </select>
            </div>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Remark:</label>
              <input 
                className="result-update-form-input"
                type="text" 
                name="remark"
                value={editingResult.remark || ''}
                onChange={handleEditChange}
              />
            </div>
            
            <div className="result-update-form-group">
              <label className="result-update-form-label">Attempt No:</label>
              <select
                className="result-update-form-select"
                name="attemptNo"
                value={editingResult.attemptNo || ''}
                onChange={handleEditChange}
                required
              >
                <option value="">Select Attempt</option>
                <option value="1st">1st</option>
                <option value="2nd">2nd</option>
                <option value="3rd">3rd</option>
              </select>
            </div>
            
            <div className="result-update-modal-actions">
              <button type="button" className="result-update-cancel-btn" onClick={handleCancel}>
                Cancel
              </button>
              <button type="button" className="result-update-save-btn" onClick={handleSave}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
)}




       
{selectedOption === "uploadPlacement" && (
  <div className="lecturer-panel-container">
    <h1>Upload Placement Assignments</h1>
    {error && <div className="error-message">{error}</div>}
    {success && <div className="success-message">{success}</div>}
    
    <form onSubmit={uploadPlacementFile}>
      <select
        className="admin-panel-select"
        value={batch}
        onChange={(e) => setBatch(e.target.value)}
        required
      >
        <option value="">Select Batch</option>
        <option value="2022-01">2022-01</option>
        <option value="2023-01">2023-01</option>
        <option value="2024-01">2024-01</option>
        <option value="2024-02">2024-02</option>
        <option value="2025-01">2025-01</option>
        <option value="2025-02">2025-02</option>
        <option value="2026-01">2026-01</option>
        <option value="2026-02">2026-02</option>
        <option value="2027-01">2027-01</option>
        <option value="2027-02">2027-02</option>
        <option value="2028-01">2028-01</option>
        <option value="2028-02">2028-02</option>
        <option value="2029-01">2029-01</option>
        <option value="2029-02">2029-02</option>
        <option value="2030-01">2030-01</option>
        <option value="2030-02">2030-02</option>
        <option value="2031-01">2031-01</option>
        <option value="2031-02">2031-02</option>
        <option value="2032-01">2032-01</option>
        <option value="2032-02">2032-02</option>
        <option value="2033-01">2033-01</option>
        <option value="2033-02">2033-02</option>
        <option value="2034-01">2034-01</option>
        <option value="2034-02">2034-02</option>
        <option value="2035-01">2035-01</option>
        <option value="2035-02">2035-02</option>
      </select>

      <div>
        <label>Course</label>
        <select
          className="admin-panel-select"
          value={id}
          onChange={(e) => setId(e.target.value)}
          required
        >
          <option value="">Select Course</option>
          <option value="CO">Certificate in Optician</option>
          <option value="DO">Diploma in Optometry</option>
          <option value="HDO">Higher Diploma in Optometry</option>
        </select>
      </div>

<div>
    <select
        className="admin-panel-select"
        value={noPlacement}
        onChange={(e) => setNoPlacement(e.target.value)}
        required
      >
        <option value="">Number Of Placement</option>
        <option value="01">01</option>
        <option value="02">02</option>
        <option value="03">03</option>
        <option value="04">04</option>
        <option value="05">05</option>
        <option value="06">06</option>
        <option value="07">07</option>
        <option value="08">08</option>
        <option value="09">09</option>
        <option value="10">10</option>
        </select>
</div>




      <div className="upload-section">
        <label className="upload-label">
          {selectedFileName ? selectedFileName : 'Choose PDF/DOCX file'}
        </label>
        <input 
          className="upload-input"
          type="file" 
          onChange={handleFilePlacementSelect} 
          accept=".pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          required
          id="file-upload"
        />
        <label htmlFor="file-upload" className="custom-file-upload">
          {selectedFileName ? 'Change File' : 'Select File'}
        </label>
        {selectedFileName && (
          <button 
            type="button" 
            className="clear-file-btn"
            onClick={() => {
              setFile(null);
              setSelectedFileName('');
              document.getElementById('file-upload').value = '';
            }}
          >
            ×
          </button>
        )}
      </div>

      <button className="upload-button" type="submit" disabled={loading}>
        {loading ? "Uploading..." : "Upload Placement Assignment"}
      </button>
    </form>
  </div>
)}









{/* 
{selectedOption === "viewAssignment" && (
<div className="lecturer-panel-container">
      <h1>Submitted Assignments</h1>
      
   
      <div className="filter-controls">
        <div className="filter-group">
          <label htmlFor="batch-filter">Filter by Batch:</label>
          <select
            id="batch-filter"
            name="batch"
            value={filters.batch}
            onChange={handleFilterChange}
          >
            <option value="">All Batches</option>
            {availableBatches.map(batch => (
              <option key={batch} value={batch}>{batch}</option>
            ))}
          </select>
        </div>
        
        <div className="filter-group">
          <label htmlFor="module-filter">Filter by Module:</label>
          <select
            id="module-filter"
            name="moduleCode"
            value={filters.moduleCode}
            onChange={handleFilterChange}
          >
            <option value="">All Modules</option>
            {availableModules.map(module => (
              <option key={module} value={module}>{module}</option>
            ))}
          </select>
        </div>
        
        <button onClick={resetFilters} className="reset-btn">
          Reset Filters
        </button>
      </div>

 




      {loading ? (
        <p>Loading submissions...</p>
      ) : filteredAssignments.length > 0 ? (
        <table className="submission-table">
          <thead>
            <tr>
              <th>Batch</th>
              <th>Module Code</th>
              <th>Module Name</th>
              <th>Submission Deadline</th>
              <th>Download Links</th>
            </tr>
          </thead>
          <tbody>
            {filteredAssignments.map((assignment, index) => (
              <tr key={index}>
                <td data-label="Batch">{assignment.batch}</td>
                <td data-label="Module Code">{assignment.moduleCode}</td>
                <td data-label="Module Name">{assignment.moduleName}</td>
                <td data-label="Submission Deadline">
                  {assignment.submissionDeadline && assignment.submissionDeadline.toDate
                    ? new Date(assignment.submissionDeadline.toDate()).toLocaleString()
                    : "Invalid Deadline"}
                </td>
                <td data-label="Download Links">
                  {assignment.files.length > 0 ? (
                    <ul>
                      {assignment.files.map((file, idx) => (
                        <li key={idx}>
                          <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="download-link"
                          >
                            {file.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No submissions for this module.</p>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No assignment submissions found matching your filters.</p>
      )}
    </div>
  )}

 */}


{selectedOption === "viewAssignment" && (
  <div className="lecturer-panel-container">
    <h1>Submitted Assignments</h1>
    
    <div className="filter-controls">
      <div className="filter-group">
        <label htmlFor="batch-filter">Filter by Batch:</label>
        <select
          id="batch-filter"
          name="batch"
          value={filters.batch}
          onChange={handleFilterChange}
        >
          <option value="">All Batches</option>
          {availableBatches.map(batch => (
            <option key={batch} value={batch}>{batch}</option>
          ))}
        </select>
      </div>
      
      <div className="filter-group">
        <label htmlFor="module-filter">Filter by Module:</label>
        <select
          id="module-filter"
          name="moduleCode"
          value={filters.moduleCode}
          onChange={handleFilterChange}
        >
          <option value="">All Modules</option>
          {availableModules.map(module => (
            <option key={module} value={module}>{module}</option>
          ))}
        </select>
      </div>
      

      
      <button onClick={resetFilters} className="reset-btn">
        Reset Filters
      </button>
    </div>

    {loading ? (
      <p>Loading submissions...</p>
    ) : filteredData.length > 0 ? (
      <table className="submission-table">
        <thead>
          <tr>
            {/* <th>Type</th> */}
            <th>Batch</th>
            <th>Module Code</th>
            <th>Module Name</th>
            {/* {filters.viewType !== 'assignments' && <th>Student Name</th>} */}
            {/* {filters.viewType !== 'assignments' && <th>Reg. Number</th>} */}
            {/* <th>Deadline</th> */}
            {/* {filters.viewType !== 'assignments' && <th>Submitted</th>} */}
            <th>Files</th>
            {/* {filters.viewType !== 'assignments' && <th>Status</th>} */}
          </tr>
        </thead>
        <tbody>
          {filteredData.map((item, index) => (
            <tr key={index} className={`${item.type}-row`}>
              {/* <td data-label="Type">
                {item.type === 'assignment' ? 'Assignment' : 'Submission'}
              </td> */}
              <td data-label="Batch">{item.batch}</td>
              <td data-label="Module Code">{item.moduleCode}</td>
              <td data-label="Module Name">{item.moduleName}</td>
              
              {/* {filters.viewType !== 'assignments' && (
                <td data-label="Student Name">
                  {item.type === 'submission' ? item.name : '-'}
                </td>
              )}
              
              {filters.viewType !== 'assignments' && (
                <td data-label="Reg. Number">
                  {item.type === 'submission' ? item.registrationNumber : '-'}
                </td>
              )} */}
              
              {/* <td data-label="Deadline">
                {item.submissionDeadline && item.submissionDeadline.toDate
                  ? new Date(item.submissionDeadline.toDate()).toLocaleString()
                  : "N/A"}
              </td>
               */}
              {/* {filters.viewType !== 'assignments' && (
                <td data-label="Submitted">
                  {item.type === 'submission' && item.submissionTime
                    ? new Date(item.submissionTime).toLocaleString()
                    : '-'}
                </td>
              )} */}
              
              <td data-label="Files">
                {item.files && item.files.length > 0 ? (
                  <ul>
                    {item.files.map((file, idx) => (
                      <li key={idx}>
                        <a
                          href={file.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="download-link"
                          download
                        >
                          {file.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No files</p>
                )}
              </td>
{/*               
              {filters.viewType !== 'assignments' && (
                <td data-label="Status">
                  {item.type === 'submission' ? (item.status || 'Submitted') : '-'}
                </td>
              )} */}
            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <p>No data found matching your filters.</p>
    )}
  </div>
)}






                
             {selectedOption === "editUser" && (
              <>
                <h1 className="admin-panel-title">Edit Student Details</h1>
                <>
    <input
      type="text"
      className="admin-panel-input"
      placeholder="Search by Name or Registration Number"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
    
    <ul className="student-list">
      {filteredStudents.map((student) => (
        <li key={student.id}>
          {student.fullName} - {student.registrationNumber || 'No Reg Number'}
          <button className="edit-panel-button" onClick={() => handleEditUser(student)}>
            Edit
          </button>
        </li>
      ))}
    </ul>
  </>
                {editingUser ? (
                  <div className="admin-panel-form">
                        <input
                          type="email"
                          className="admin-panel-input"
                          placeholder="Email"
                          value={editingUser.email || ""}
                          readOnly
                        />

                    <input
                      type="text"
                      className="admin-panel-input"
                      placeholder="Full Name"
                      value={editingUser.fullName || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, fullName: e.target.value }))
                      }
                    />
                    <input
                      type="text"
                       className="admin-panel-select"
                      placeholder="Registration Number"
                      value={editingUser.registrationNumber || ''}
                      onChange={(e) => setEditingUser(prev => ({
                        ...prev,
                        registrationNumber: e.target.value || null
                      }))}
                    />
                     <select
                      className="admin-panel-select"
                      value={editingUser.program || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, program: e.target.value }))
                      }
                    >
                      <option value="">Select Course</option>
                      <option value="Certificate in Optician">Certificate in Optician</option>
                      <option value="Diploma in Optometry">Diploma in Optometry</option>
                      <option value="Higher Diploma in Optometry">Higher Diploma in Optometry</option>
                    </select>
                    <select
                      className="admin-panel-select"
                      value={editingUser.courseType || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, courseType: e.target.value }))
                      }
                    >
                      <option value="">Select Course Type</option>
                      <option value="Full Time">Full Time</option>
                      <option value="Part Time">Part Time</option>
                    </select>

                    <input
                      type="text"
                      className="admin-panel-input"
                      placeholder="Course Fee"
                      value={editingUser.courseFee || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, courseFee: e.target.value }))
                      }
                    />

                    <input
                      type="text"
                      className="admin-panel-input"
                      placeholder="NIC/Passport Number"
                      value={editingUser.nicPassport || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, nicPassport: e.target.value }))
                      }
                    />
                    <input
                      type="text"
                      className="admin-panel-input"
                      placeholder="Contact Number"
                      value={editingUser.contactNo || ""}
                      onChange={(e) =>
                        setEditingUser((prev) => ({ ...prev, contactNo: e.target.value }))
                      }
                    />




             <select
              className="admin-panel-select"
              value={editingUser.batch || ""}
              onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, batch: e.target.value }))
              }

              >
              <option value="">Select Batch</option>
              <option value="2022-01">2022-01</option>
              <option value="2023-01">2023-01</option>
              <option value="2024-01">2024-01</option>
              <option value="2024-02">2024-02</option>
              <option value="2025-01">2025-01</option>
              <option value="2025-02">2025-02</option>
              <option value="2026-01">2026-01</option>
              <option value="2026-02">2026-02</option>
              <option value="2027-01">2027-01</option>
              <option value="2027-02">2027-02</option>
              <option value="2028-01">2028-01</option>
              <option value="2028-02">2028-02</option>
              <option value="2029-01">2029-01</option>
              <option value="2029-02">2029-02</option>
              <option value="2030-01">2030-01</option>
              <option value="2030-02">2030-02</option>
              <option value="2031-01">2031-01</option>
              <option value="2031-02">2031-02</option>
              <option value="2032-01">2032-01</option>
              <option value="2032-02">2032-02</option>
              <option value="2033-01">2033-01</option>
              <option value="2033-02">2033-02</option>
              <option value="2034-01">2034-01</option>
              <option value="2034-02">2034-02</option>
              <option value="2035-01">2035-01</option>
              <option value="2035-02">2035-02</option>
            </select>
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Address"
            value={editingUser.address || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, address: e.target.value }))
            }
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="First Name"
            value={editingUser.firstName || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, firstName: e.target.value }))
            }
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Last Name"
            value={editingUser.lastName || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, lastName: e.target.value }))
            }
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Full Name"
            value={editingUser.fullName || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, fullName: e.target.value }))

            }
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Name with Initial"
            value={editingUser.nameWithInitial || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, nameWithInitial: e.target.value }))
            }
          />

 
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Name to be appeared on the certificate"
            value={editingUser.nameToBeAppeared || ""}
            onChange={(e) => 
              setEditingUser((prev) => ({ ...prev, nameToBeAppeared: e.target.value }))

            }
          />



                    <button className="admin-panel-button" onClick={handleUpdateUser}>
                      Save Changes
                    </button>
                    <button
                      className="admin-panel-button"
                      onClick={() => setEditingUser(null)}
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <div className="editable-student-container">
                  <h2>Select a Student to Edit</h2>
                  <ul className="student-list">
                    {students.map((student) => (
                      <li key={student.id}>
                        {student.fullName} - {student.registrationNumber || 'No Reg Number'}
                        <button
                          className="edit-panel-button"
                          onClick={() => handleEditUser(student)}
                        >
                          Edit
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
                )}
              </>
            )} 
















       {selectedOption === "uploadStudyMaterialLink" && (
        <>
          <h1 className="admin-panel-title"> Upload Study Material Link - Google Classroom</h1>
          <div className="upload-quiz-master-link">

            {/* Form for uploading quiz link */}
            <form onSubmit={uploadGoogleClassroomLink}>
              <div>
                <label>Course Type (ID)</label>
                <select
                  className="admin-panel-select"
                  value={courseType}
                  onChange={(e) => setCourseType(e.target.value)}
                  required
                >
                  <option value="">Select Course Type</option>
                  <option value="CO">Certificate in Optician</option>
                  <option value="DO">Diploma in Optometry</option>
                  <option value="HDO">Higher Diploma in Optometry</option>
                </select>
              </div>


              <div className="quiz-link-admin">
                <label>Google classroom section's Link</label>
                <input
                  type="text"
                  value={googleclassroomLink}
                  onChange={(e) => setGoogleClassroomLink(e.target.value)}
                  placeholder="Paste your link here"
                  required
                />
              </div>

              <button className="quiz-generate-button" type="submit">Upload Google Classroom Link</button>
            </form>

            {/* Display success or error messages */}
            {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
          </div>
        </>
      )}







{selectedOption === "uploadLectureRecordingLink" && (
  <>
    <h1 className="admin-panel-title">Upload Previous Lecture Recording Link</h1>
    <div className="upload-quiz-master-link">
      <form onSubmit={uploadRecordingLink}>
        <div>
          <label>Course Type (ID)</label>
          <select
            className="admin-panel-select"
            value={courseType}
            onChange={(e) => setCourseType(e.target.value)}
            required
          >
            <option value="">Select Course Type</option>
            <option value="CO">Certificate in Optician</option>
            <option value="DO">Diploma in Optometry</option>
            <option value="HDO">Higher Diploma in Optometry</option>
          </select>
        </div>

        <div>
          <label>Module</label>
          <select
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          >
            <option value="">Select Module</option>
            {courseType === "CO" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Equipment">Understanding Equipment</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
              </>
            )}
            {courseType === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

              {courseType === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

          </select>
        </div>

        <div>
          <label>Session No.</label>
          <select
            className="admin-panel-select"
            value={session}
            onChange={(e) => setSession(e.target.value)}
            required
          >
            <option value="">Select Session No</option>
            {[...Array(15)].map((_, index) => (
              <option key={index} value={`Session ${index + 1}`}>
                Session {index + 1}
              </option>
            ))}
          </select>
        </div>

        <div className="quiz-link-admin">
          <label>Lecture Recording Link</label>
          <input
            type="text"
            value={lectureRecordingLink}
            onChange={(e) => setLectureRecordingLink(e.target.value)}
            placeholder="Paste your link here"
            required
          />
        </div>

        <button className="quiz-generate-button" type="submit">
          Upload Lecture Recording Link
        </button>
      </form>

      {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
    </div>
  </>
)}

















     {selectedOption === "uploadQuizMasterLink" && (
        <>
          <h1 className="admin-panel-title">Upload Quiz Master Link</h1>
          <div className="upload-quiz-master-link">
            {/* Form for uploading quiz link */}
            <form onSubmit={uploadQuizLink}>
              <div>
                <label>Course Type (ID)</label>
                <select
                  className="admin-panel-select"
                  value={courseType}
                  onChange={(e) => setCourseType(e.target.value)}
                  required
                >
                  <option value="">Select Course Type</option>
                  <option value="CO">Certificate in Optician</option>
                  <option value="DO">Diploma in Optometry</option>
                  <option value="HDO">Higher Diploma in Optometry</option>
                </select>
              </div>

              <div>
          <label>Module</label>
          <select
                  className="admin-panel-select"
                  value={moduleName}
                  onChange={(e) => setModuleName(e.target.value)}
                  required
                >
                  <option value="">Select Module</option>
                  {courseType === "CO" && (
                    <>
                      <option value="" disabled>------ CO Modules ------</option>
                      <option value="General Science">General Science</option>
                      <option value="Optics">Optics</option>
                      <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                      <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                      <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                      <option value="Common Eye Diseases">Common Eye Diseases</option>
                      <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                      <option value="Understanding Equipment">Understanding Equipment</option>
                      <option value="Sales & Marketing">Sales & Marketing</option>
                    </>
                  )}
                  {courseType === "DO" && (
                    <>
                      <option value="" disabled>------ DO Modules ------</option>
                      <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                      <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                      <option value="Biochemistry">Biochemistry</option>
                      <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                      <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                      <option value="Ocular pathology I">Ocular pathology I</option>
                      <option value="Clinical procedure I">Clinical procedure I</option>
                      <option value="Visual optics">Visual optics</option>
                      <option value="Pharmacology">Pharmacology</option>
                      <option value="Physiology of vision">Physiology of vision</option>
                      <option value="General Medicine">General Medicine</option>
                      <option value="Clinical procedure II">Clinical procedure II</option>
                      <option value="Ocular pathology II">Ocular pathology II</option>
                      <option value="Binocular Vision">Binocular Vision</option>
                      <option value="Contact lens">Contact lens</option>
                      <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                      <option value="Low Vision">Low Vision</option>
                      <option value="Dispensing Optics">Dispensing Optics</option>
                      <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                      <option value="Occupational Optometry">Occupational Optometry</option>
                      <option value="Practice Management">Practice Management</option>
                      <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                    </>
                  )}

                   {courseType === "HDO" && (
                    <>
                      <option value="" disabled>------ DO Modules ------</option>
                      <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                      <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                      <option value="Biochemistry">Biochemistry</option>
                      <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                      <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                      <option value="Ocular pathology I">Ocular pathology I</option>
                      <option value="Clinical procedure I">Clinical procedure I</option>
                      <option value="Visual optics">Visual optics</option>
                      <option value="Pharmacology">Pharmacology</option>
                      <option value="Physiology of vision">Physiology of vision</option>
                      <option value="General Medicine">General Medicine</option>
                      <option value="Clinical procedure II">Clinical procedure II</option>
                      <option value="Ocular pathology II">Ocular pathology II</option>
                      <option value="Binocular Vision">Binocular Vision</option>
                      <option value="Contact lens">Contact lens</option>
                      <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                      <option value="Low Vision">Low Vision</option>
                      <option value="Dispensing Optics">Dispensing Optics</option>
                      <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                      <option value="Occupational Optometry">Occupational Optometry</option>
                      <option value="Practice Management">Practice Management</option>
                      <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                    </>
                  )}


          </select>
        </div>
              



              <div>
                <label>No OF Test</label>
                <select
                  className="admin-panel-select"
                  value={Test}
                  onChange={(e) => setTest(e.target.value)}
                  required
                >
                  <option value="">Select No of Test</option>
                  <option value="Test 01">Test 01</option>
                  <option value="Test 02">Test 02</option>
                  <option value="Test 03">Test 03</option>
                  <option value="Test 04">Test 04</option>                  
                  <option value="Test 05">Test 05</option>                  
                  <option value="Test 06">Test 06</option>                  
                  <option value="Test 07">Test 07</option>                  
                  <option value="Test 08">Test 08</option>                  
                  <option value="Test 09">Test 09</option>                 
                  <option value="Test 10">Test 10</option>                 
                  <option value="Test 11">Test 11</option>                
                  <option value="Test 12">Test 12</option>                 
                  <option value="Test 13">Test 13</option>                  
                  <option value="Test 14">Test 14</option>               
                  <option value="Test 15">Test 15</option>
                </select>
              </div>


              <div className="quiz-link-admin">
                <label>Quiz Link</label>
                <input
                  type="text"
                  value={quizLink}
                  onChange={(e) => setQuizLink(e.target.value)}
                  placeholder="Paste your link here"
                  required
                />
              </div>

              <button className="quiz-generate-button" type="submit">Upload Link</button>
            </form>

            {/* Display success or error messages */}
            {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
          </div>
        </>
      )}



  {/************************************************************************************************************************/}      





{/* {selectedOption === "paymentDetails" && (
  <>
    <h1 className="admin-panel-title">Student Payment Details</h1>

  


    <div className="search-payment">
      <input
        type="text"
        placeholder={`Search by ${searchOption}`}
        value={searchQuery}
        onChange={handleSearchChange}
      />
      <select value={searchOption} onChange={handleSearchOptionChange}>
        <option value="name">Name</option>
        <option value="registrationNumber">Registration Number</option>
      </select>
    </div>


    <div className="table-container">
      <table className="payment-table">
        <thead>
          <tr>
            <th>Student ID</th>
            <th>Student Name</th>
            <th>Total Paid</th>
            <th>Outstanding Amount</th>
            <th>Payment Details</th>
          </tr>
        </thead>
        <tbody>
          {filteredStudents.map((student) => (
            <tr key={student.id}>
              <td>{student.registrationNumber}</td>
              <td>{student.fullName}</td>
              <td>{student.totalPaid}</td>
              <td>{student.outstandingAmount}</td>
              <td>
                <ul>
                  {student.payments.map((payment) => (
                    <li key={payment.id}>
                      Receipt No: {payment.receiptNo}, Amount: {payment.amount}, Date: {payment.paymentDate.toDate().toLocaleDateString()}
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </>
)}
 */}

{selectedOption === "paymentDetails" && (
  <>
    <h1 className="admin-panel-title">Student Payment Details</h1>

    {/* Search Bar */}
    <div className="search-payment">
      <input
        type="text"
        placeholder={`Search by ${searchOption}`}
        value={searchQuery}
        onChange={handleSearchChange}
      />
      <select value={searchOption} onChange={handleSearchOptionChange}>
        <option value="name">Name</option>
        <option value="registrationNumber">Registration Number</option>
      </select>
    </div>

    {/* Student Payments Table */}
    <div className="table-container">
      <table className="payment-table">
        <thead>
          <tr>
            <th>Student ID</th>
            <th>Student Name</th>
            <th>Total Paid</th>
            <th>Outstanding Amount</th>
            <th>Payment Details</th>
          </tr>
        </thead>
        <tbody>
          {filteredStudents && filteredStudents.length > 0 ? (
            filteredStudents.map((student) => (
              <tr key={student.id}>
                <td>{student.registrationNumber || 'N/A'}</td>
                <td>{student.fullName || 'N/A'}</td>
                <td>{student.totalPaid || 0}</td>
                <td>{student.outstandingAmount || 0}</td>
                <td>
                  <ul className="payment-list">
                    {student.payments && student.payments.length > 0 ? (
                      student.payments.map((payment) => (
                        <li key={payment.id} className="payment-item">
                          <div className="payment-info">
                            Receipt No: {payment.receiptNo || 'N/A'}, 
                            Amount: {payment.amount || 0}, 
                            Date: {payment.paymentDate?.toDate().toLocaleDateString() || 'N/A'}
                          </div>
                          <button 
                            className="delete-payment-btn"
                            onClick={() => deletePayment(payment.id)}
                          >
                            Delete
                          </button>
                        </li>
                      ))
                    ) : (
                      <li>No payments found</li>
                    )}
                  </ul>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: 'center' }}>
                No students found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </>
)}



  {/************************************************************************************************************************/}      



  {selectedOption === "createAccount" && (
    <>
      <h1 className="admin-panel-title">Create User Account</h1>
      <div className="admin-panel-form">
        {/* Input Fields */}
            <input 
            type="email" 
            className="admin-panel-input" 
            placeholder="Email" 
            value={email} onChange={(e) => setEmail(e.target.value)} 
            />
       {/* 
          <input
            type="password"
            className="admin-panel-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          /> */}


<div style={{ position: "relative", width: "100%" }}>
  <input
    type={showPassword ? "text" : "password"}
    placeholder="Password"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    style={{
      width: "100%",
      padding: "12px 50px 12px 15px",
      border: "2px solid #ccc",
      borderRadius: "5px",
      outline: "none",
      fontSize: "16px",
      transition: "all 0.3s ease",
      boxShadow: "inset 0 2px 5px rgba(0, 0, 0, 0.1)",
      margin: "0",
      boxSizing: "border-box",
      marginBottom:"15px"
    }}
  />
  <button
    type="button"
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: "absolute",
      top: "50%",
      right: "15px",
      transform: "translateY(-50%)",
      background: "transparent",
      border: "none",
      cursor: "pointer",
      color: "#aaa",
      transition: "color 0.3s",
      padding: "5px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
  </button>
</div>




          <select
            className="admin-panel-select"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          >
            <option value="">Select Role</option>
            <option value="lecturer">Lecturer</option>
            <option value="student">Student</option>
          </select>
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Registration Number"
            value={registrationNumber}
            onChange={(e) => setRegistrationNumber(e.target.value)}
          />
            <select
            className="admin-panel-select"
            value={program}
            onChange={(e) => setProgram(e.target.value)}
          >
            <option value="">Select Course </option>
            <option value="Certificate in Optician">Certificate in Optician</option>
            <option value="Diploma in Optometry">Diploma in Optometry</option>
            <option value="Higher Diploma in Optometry">Higher Diploma in Optometry</option>
          </select>

            <select
            className="admin-panel-select"
            value={courseType}
            onChange={(e) => setCourseType(e.target.value)}
          >
            <option value="">Select Course Type</option>
            <option value="Full Time">Full Time</option>
            <option value="Part Time">Part Time</option>
          </select>
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Course Fee"
            value={courseFee}
            onChange={(e) => setCourseFee(e.target.value)}
          />
                     
              <select
              className="admin-panel-select"
              value={batch}
              onChange={(e) => setBatch(e.target.value)}
              >
              <option value="">Select Batch</option>
              <option value="2022-01">2022-01</option>
              <option value="2023-01">2023-01</option>
              <option value="2024-01">2024-01</option>
              <option value="2024-02">2024-02</option>
              <option value="2025-01">2025-01</option>
              <option value="2025-02">2025-02</option>
              <option value="2026-01">2026-01</option>
              <option value="2026-02">2026-02</option>
              <option value="2027-01">2027-01</option>
              <option value="2027-02">2027-02</option>
              <option value="2028-01">2028-01</option>
              <option value="2028-02">2028-02</option>
              <option value="2029-01">2029-01</option>
              <option value="2029-02">2029-02</option>
              <option value="2030-01">2030-01</option>
              <option value="2030-02">2030-02</option>
              <option value="2031-01">2031-01</option>
              <option value="2031-02">2031-02</option>
              <option value="2032-01">2032-01</option>
              <option value="2032-02">2032-02</option>
              <option value="2033-01">2033-01</option>
              <option value="2033-02">2033-02</option>
              <option value="2034-01">2034-01</option>
              <option value="2034-02">2034-02</option>
              <option value="2035-01">2035-01</option>
              <option value="2035-02">2035-02</option>
            </select>
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Full Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Name with Initial"
            value={nameWithInitial}
            onChange={(e) => setNameWithInitial(e.target.value)}
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="NIC/Passport Number"
            value={nicPassport}
            onChange={(e) => setNicPassport(e.target.value)}
          />

          <input
            type="tel"
            className="admin-panel-input"
            placeholder="Contact Number"
            value={contactNo}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '').slice(0, 10);
              setContactNo(value);
            }}
            maxLength="10"
          />
          <input
            type="text"
            className="admin-panel-input"
            placeholder="Name to be appeared on the certificate"
            value={nameToBeAppeared}
            onChange={(e) => setNameToBeAppeared(e.target.value)}
          />
          <button className="admin-panel-button" onClick={createAccount}>
            Create Account
          </button>
          </div>
        </>
      )}


  {/************************************************************************************************************************/}      


      {selectedOption === "viewAllUsers" && (
        <>
          <h1 className="admin-panel-title">Manage Users</h1>
          <div className="user-list scroll-container">{renderUsersByRole()}</div>

        </>
      )}


        
  {/************************************************************************************************************************/}      


        {selectedOption === "manageUsers" && (
      <>
          <h1 className="admin-panel-title">View All Users</h1>

          <button onClick={downloadUsers} className="all-user-download-button">
            Download All Users
          </button>

          <div className="search-bar">
            <input
              type="text"
              placeholder={`Search by ${searchOption}`}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <select
              value={searchOption}
              onChange={(e) => setSearchOption(e.target.value)}
            >
              <option value="name">Name</option>
              <option value="registrationNumber">Registration Number</option>
            </select>
          </div>
          <div className="user-list scroll-container">{renderFilteredUsers()}</div>

        </>
        )}

  {/************************************************************************************************************************/}      


          {/* {selectedOption === "createNotices" && (
            <div>
              <h1 className="admin-panel-title">Create Notices</h1>
              <div className="admin-panel-form">
                <input
                  type="text"
                  className="admin-panel-input"
                  placeholder="Subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
                <textarea
                  className="admin-panel-input"
                  placeholder="Notice"
                  value={notice}
                  onChange={(e) => setNotice(e.target.value)}
                  rows="5"
                ></textarea>
                <input
                  type="datetime-local"
                  className="admin-panel-input"
                  value={addedDate}
                  onChange={(e) => setAddedDate(e.target.value)}
                />
                <button className="admin-panel-button" onClick={createNotice}>
                  Create Notice
                </button>
              </div>
            </div>
          )} */}





{selectedOption === "createNotices" && (
  <div>
    <h1 className="admin-panel-title">Create Notices</h1>
    <div className="admin-panel-form">
      <input
        type="text"
        className="admin-panel-input"
        placeholder="Subject"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
      />
      <textarea
        className="admin-panel-input"
        placeholder="Notice"
        value={notice}
        onChange={(e) => setNotice(e.target.value)}
        rows="5"
      ></textarea>
      <input
        type="datetime-local"
        className="admin-panel-input"
        value={addedDate}
        onChange={(e) => setAddedDate(e.target.value)}
      />
      
      {/* Image upload checkbox and input */}
      <div className="image-upload-section">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={hasImage}
            onChange={(e) => {
              setHasImage(e.target.checked);
              if (!e.target.checked) {
                setImageFile(null);
                setImageUrl('');
              }
            }}
          />
          Include Image
        </label>
        
        {hasImage && (
          <div className="image-upload-controls">
            <input
              type="file"
              id="notice-image"
              accept="image/*"
              onChange={(e) => {
                if (e.target.files[0]) {
                  setImageFile(e.target.files[0]);
                }
              }}
              disabled={!hasImage}
            />
            {imageFile && (
              <div className="image-preview">
                <p>Selected: {imageFile.name}</p>
              </div>
            )}
          </div>
        )}
      </div>
      
      <button 
        className="admin-panel-button" 
        onClick={createNotice}
        disabled={isUploading}
      >
        {isUploading ? 'Uploading...' : 'Create Notice'}
      </button>
    </div>
  </div>
)}



  {/************************************************************************************************************************/}      

            {selectedOption === "createModulesForCourses" && (
              <div className="module-form-container">
              <h1>Create Course Module</h1>
              {error && <p className="error-message">{error}</p>}
              {success && <p className="success-message">{success}</p>}
          
              <form onSubmit={handleSubmit} className="module-form">
                <select
                  className="admin-panel-select"
                  name="semester"
                  value={moduleData.semester}
                  onChange={handleChange}
                >
                  <option value="">Select Semester</option>
                  <option value="Y1 S1">Y1 S1</option>
                  <option value="Y1 S2">Y1 S2</option>
                  <option value="Y2 S3">Y2 S3</option>
                  <option value="Y2 S4">Y2 S4</option>
                  <option value="Y3 S5">Y3 S5</option>
                </select>
          
                <div className="input-group">
                  <label>Module Code</label>
                  <input
                    type="text"
                    name="moduleCode"
                    value={moduleData.moduleCode}
                    onChange={handleChange}
                    required
                    className="input-field"
                  />
                </div>
          
                <div className="input-group">
                  <label>Module Name</label>
                  <input
                    type="text"
                    name="moduleName"
                    value={moduleData.moduleName}
                    onChange={handleChange}
                    required
                    className="input-field"
                  />
                </div>
          
                <div className="input-group">
                  <label>Program Id</label>
                  <input
                    type="text"
                    name="id"
                    placeholder="CO / DO / HDO"
                    value={moduleData.id}
                    onChange={handleChange}
                    required
                    className="input-field"
                  />
                </div>
          
                <button type="submit" disabled={loading} className="submit-button">
                  {loading ? "Creating..." : "Create Module"}
                </button>
              </form>
            </div>
            )}

  {/************************************************************************************************************************/}      


            {selectedOption === "uploadMaterial" && (
              <div className="upload-material-container">
                <h1>Upload Lecture Material</h1>

                {/* File upload form */}
                <form onSubmit={uploadFile}>
                <select
              className="admin-panel-select"
              value={batch}
              onChange={(e) => setBatch(e.target.value)}
              >
              <option value="">Select Batch</option>
              <option value="2023-01">2023-01</option>
              <option value="2024-01">2024-01</option>
              <option value="2024-02">2024-02</option>
              <option value="2025-01">2025-01</option>
              <option value="2025-02">2025-02</option>
              <option value="2026-01">2026-01</option>
              <option value="2026-02">2026-02</option>
              <option value="2027-01">2027-01</option>
              <option value="2027-02">2027-02</option>
              <option value="2028-01">2028-01</option>
              <option value="2028-02">2028-02</option>
              <option value="2029-01">2029-01</option>
              <option value="2029-02">2029-02</option>
              <option value="2030-01">2030-01</option>
              <option value="2030-02">2030-02</option>
              <option value="2031-01">2031-01</option>
              <option value="2031-02">2031-02</option>
              <option value="2032-01">2032-01</option>
              <option value="2032-02">2032-02</option>
              <option value="2033-01">2033-01</option>
              <option value="2033-02">2033-02</option>
              <option value="2034-01">2034-01</option>
              <option value="2034-02">2034-02</option>
              <option value="2035-01">2035-01</option>
              <option value="2035-02">2035-02</option>
            </select>
                  <div>
                    <label>Course</label>
                    <select
                    className="admin-panel-select"
                      type="text"
                      value={id}
                      onChange={(e) => setId(e.target.value)}
                      placeholder="CO / DO / HDO"
                    >
                      <option value="">Select Course</option>
                      <option value="CO">Certificate in Optician</option>
                      <option value="DO">Diploma in Optometry</option>
                       <option value="HDO">Higher Diploma in Optometry</option>
                      </select>
                  </div>



 <div>
                <label htmlFor="moduleCode">Module Code:</label>
          <select
            className="admin-panel-select"
            value={moduleCode}
            onChange={(e) => setModuleCode(e.target.value)}
            required
          >
            <option value="">Select Module Code</option>
            {id === "CO" && (
              <>
                <option value="" disabled>---- CO Modules Code ----</option>
                <option value="CO101">General Science - CO101 </option>
                <option value="CO102">Optics - CO102</option>
                <option value="CO103">Anatomy & Physiology of Eye - CO103</option>
                <option value="CO104">Common Eye Diseases - CO104</option>
                <option value="CO105">Clinical Optics & Refraction - CO105</option>
                <option value="CO201">Understanding Prescription & Ocular Measurement - CO201</option>
                <option value="CO202">Ophthalmic Lens & Frame - CO202</option>
                <option value="CO203">Understanding Equipment - CO203</option>
                <option value="CO204">Sales & Marketing - CO204</option>
              </>
            )}
            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}

            {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}
          </select>
        </div>

        <div>
          <label>Module Name</label>
          <input
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          />
            {/* <option value="">Select Module</option>
            {id === "CO" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Equipment">Understanding Equipment</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
              </>
            )}
            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical& Physical">Optics- Geometrical& Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </> 
            )}*/}
      
        </div>



                  <div>
                    <label>Choose file</label>
                    <input type="file" onChange={handleFileSelect} />
                  </div>
                  {error && <p>{error}</p>}
                  <button type="submit" disabled={loading}>
                    {loading ? "Uploading..." : "Upload Material"}
                  </button>
                </form>
              </div>
            )}



{/************************************************************************************************************************/}      


            {selectedOption === "createAssignmentDeadline" && (
              <div className="assignment-form-container">
                <h1>Create Assignment Deadline Link</h1>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleCreateAssignment();
                  }}
                >
      <div>
          <label>Select Course</label>
          <select
            className="admin-panel-select"
            value={id}
            onChange={(e) => setId(e.target.value)}
            required
          >
            <option value="">Select Course</option>
            <option value="CO">Certificate in Optician</option>
            <option value="DO">Diploma in Optometry</option>
            <option value="HDO">Higher Diploma in Optometry</option>
          </select>
        </div>


                  <select
                    className="admin-panel-select"
                    value={batch}
                    onChange={(e) => setBatch(e.target.value)}
                    >
                    <option value="">Select Batch</option>
                    <option value="2023-01">2023-01</option>
                    <option value="2024-01">2024-01</option>
                    <option value="2024-02">2024-02</option>
                    <option value="2025-01">2025-01</option>
                    <option value="2025-02">2025-02</option>
                    <option value="2026-01">2026-01</option>
                    <option value="2026-02">2026-02</option>
                    <option value="2027-01">2027-01</option>
                    <option value="2027-02">2027-02</option>
                    <option value="2028-01">2028-01</option>
                    <option value="2028-02">2028-02</option>
                    <option value="2029-01">2029-01</option>
                    <option value="2029-02">2029-02</option>
                    <option value="2030-01">2030-01</option>
                    <option value="2030-02">2030-02</option>
                    <option value="2031-01">2031-01</option>
                    <option value="2031-02">2031-02</option>
                    <option value="2032-01">2032-01</option>
                    <option value="2032-02">2032-02</option>
                    <option value="2033-01">2033-01</option>
                    <option value="2033-02">2033-02</option>
                    <option value="2034-01">2034-01</option>
                    <option value="2034-02">2034-02</option>
                    <option value="2035-01">2035-01</option>
                    <option value="2035-02">2035-02</option>
                  </select>

                

                  <div>
                <label htmlFor="moduleCode">Module Code:</label>
          <select
            className="admin-panel-select"
            value={moduleCode}
            onChange={(e) => setModuleCode(e.target.value)}
            required
          >
            <option value="">Select Module Code</option>
            {id === "CO" && (
              <>
                <option value="" disabled>---- CO Modules Code ----</option>
                <option value="-">Placement Assesment </option>
                <option value="CO101">General Science - CO101 </option>
                <option value="CO102">Optics - CO102</option>
                <option value="CO103">Anatomy & Physiology of Eye - CO103</option>
                <option value="CO104">Common Eye Diseases - CO104</option>
                <option value="CO105">Clinical Optics & Refraction - CO105</option>
                <option value="CO201">Understanding Prescription & Ocular Measurement - CO201</option>
                <option value="CO202">Ophthalmic Lens & Frame - CO202</option>
                <option value="CO203">Understanding Equipment - CO203</option>
                <option value="CO204">Sales & Marketing - CO204</option>
              </>
            )}
            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="-">Placement Assessment - PLC000 </option>
                <option value="-">Information Technology</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}
             {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="-">Placement Assessment - PLC000 </option>
                <option value="-">Information Technology</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}
          </select>
        </div>

              <div>
          <label>Module Name</label>
          <select
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          >
            <option value="">Select Module</option>
            {id === "CO" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="Placement Assessment">Placement Assessment</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Ophthalmic Equipment - Lensometer">Understanding Ophthalmic Equipment - Lensometer</option>
                <option value="Understanding Ophthalmic Equipment - Visual Acuity">Understanding Ophthalmic Equipment - Visual Acuity</option>
                <option value="Understanding Ophthalmic Equipment - Trial Box">Understanding Ophthalmic Equipment - Trial Box</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}
            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="Placement Assessment">Placement Assessment</option>
                 <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics - Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}

            {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="Placement Assessment">Placement Assessment</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics - Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}
          </select>
        </div>


                
                  <div className="form-field">
                    <label>
                      Submission Deadline:
                       <input
                        type="datetime-local"
                        value={submissionDeadline}
                        onChange={(e) => setSubmissionDeadline(e.target.value)}
                        required
                      />
                    </label>
                  </div>
    
                  <button type="submit" disabled={loading}>
                    {loading ? "Creating..." : "Create Assignment Deadline"}
                  </button>
                </form>
              </div>
            )}








{/*******************************  assignment deadline for mitigate students ***********************************************/}



{selectedOption === "mitigatetDeadline" && (
              <div className="assignment-form-container">
                <h1>Create Assignment Deadline Link for Mitigate Student</h1>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleCreateAssignmentForMitigate();
                  }}
                >

      <div>
          <label>Select Course</label>
          <select
            className="admin-panel-select"
            value={id}
            onChange={(e) => setId(e.target.value)}
            required
          >
            <option value="">Select Course Type</option>
            <option value="CO">Certificate in Optician</option>
            <option value="DO">Diploma in Optometry</option>
            <option value="HDO">Higher Diploma in Optometry</option>
          </select>
        </div>


                  <div className="form-field">
                    <label>
                      Student Registration No:
                      <input
                        type="text"
                        value={registrationNumber}
                        onChange={(e) => setRegistrationNumber(e.target.value)}
                        required
                      />
                    </label>
                  </div>


                  <select
                    className="admin-panel-select"
                    value={batch}
                    onChange={(e) => setBatch(e.target.value)}
                    >
                    <option value="">Select Batch</option>
                    <option value="2023-01">2023-01</option>
                    <option value="2024-01">2024-01</option>
                    <option value="2024-02">2024-02</option>
                    <option value="2025-01">2025-01</option>
                    <option value="2025-02">2025-02</option>
                    <option value="2026-01">2026-01</option>
                    <option value="2026-02">2026-02</option>
                    <option value="2027-01">2027-01</option>
                    <option value="2027-02">2027-02</option>
                    <option value="2028-01">2028-01</option>
                    <option value="2028-02">2028-02</option>
                    <option value="2029-01">2029-01</option>
                    <option value="2029-02">2029-02</option>
                    <option value="2030-01">2030-01</option>
                    <option value="2030-02">2030-02</option>
                    <option value="2031-01">2031-01</option>
                    <option value="2031-02">2031-02</option>
                    <option value="2032-01">2032-01</option>
                    <option value="2032-02">2032-02</option>
                    <option value="2033-01">2033-01</option>
                    <option value="2033-02">2033-02</option>
                    <option value="2034-01">2034-01</option>
                    <option value="2034-02">2034-02</option>
                    <option value="2035-01">2035-01</option>
                    <option value="2035-02">2035-02</option>
                  </select>




                  <div>
          <label>Module Name</label>
          <select
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          >
            <option value="">Select Module</option>
            {id === "CO" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Ophthalmic Equipment - Lensometer">Understanding Ophthalmic Equipment - Lensometer</option>
                <option value="Understanding Ophthalmic Equipment - Visual Acuity">Understanding Ophthalmic Equipment - Visual Acuity</option>
                <option value="Understanding Ophthalmic Equipment - Trial Box">Understanding Ophthalmic Equipment - Trial Box</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}

            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}

             {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
                <option value="placement assessment">Placement Assessment</option>
              </>
            )}

          </select>
        </div>




        <div>
                <label htmlFor="moduleCode">Module Code:</label>
          <select
            className="admin-panel-select"
            value={moduleCode}
            onChange={(e) => setModuleCode(e.target.value)}
            required
          >
            <option value="">Select Module Code</option>
            {id === "CO" && (
              <>
                <option value="" disabled>---- CO Modules Code ----</option>
                <option value="CO101">General Science - CO101 </option>
                <option value="CO102">Optics - CO102</option>
                <option value="CO103">Anatomy & Physiology of Eye - CO103</option>
                <option value="CO104">Common Eye Diseases - CO104</option>
                <option value="CO105">Clinical Optics & Refraction - CO105</option>
                <option value="CO201">Understanding Prescription & Ocular Measurement - CO201</option>
                <option value="CO202">Ophthalmic Lens & Frame - CO202</option>
                <option value="CO203">Understanding Equipment - CO203</option>
                <option value="CO204">Sales & Marketing - CO204</option>
              </>
            )}
            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="-">Information Technology</option>
               <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}

             {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="-">Information Technology</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}
          </select>
        </div>


                  <div className="form-field">
                    <label>
                      Submission Deadline:
                       <input
                        type="datetime-local"
                        value={submissionDeadline}
                        onChange={(e) => setSubmissionDeadline(e.target.value)}
                        required
                      />
                    </label>
                  </div>
    
                  <button type="submit" disabled={loading}>
                    {loading ? "Creating..." : "Create Assignment Deadline"}
                  </button>
                </form>
              </div>
            )}


{/************************************************************************************************************************/}      





        {selectedOption === "outstandingPayments" && (
          <>
            <h1 className="admin-panel-title">Outstanding Payments</h1>
            <div className="payment-update-container">
              {/* Type of Course Dropdown */}
              <select
                className="admin-panel-select"
                value={courseType}
                onChange={(e) => setCourseType(e.target.value)}
              >
                <option value="">Select Course Type</option>
                <option value="Certificate in Optician">Certificate in Optician</option>
                <option value="Diploma in Optometry">Diploma in Optometry</option>
                <option value="Higher Diploma in Optometry">Higher Diploma in Optometry</option>
              </select>

              {/* Batch Dropdown */}
              <select
                className="admin-panel-select"
                value={batch}
                onChange={(e) => setBatch(e.target.value)}
              >
                <option value="">Select Batch</option>
                {Array.from({ length: 13 }, (_, i) => {
                  const year = 2023 + i;
                  return (
                    <>
                      <option key={`${year}-01`} value={`${year}-01`}>{`${year}-01`}</option>
                      <option key={`${year}-02`} value={`${year}-02`}>{`${year}-02`}</option>
                    </>
                  );
                })}
              </select>

              {/* Submit Button */}
              <button onClick={handlePaymentSubmit} className="submit-btn" disabled={loading}>
                Submit
              </button>

              {/* Clear Button */}
              <button onClick={handleClear} className="clear-btn" disabled={loading}>
                Clear
              </button>
            </div>

            {/* Display Loading Indicator */}
            {loading && (
              <div className="loading-status">
                <p>Loading...</p>  {/* You can replace this with a spinner or any other indicator */}
              </div>
            )}

            {/* Display Total Outstanding Payment */}
            {isSubmitted && !loading && (
              <div className="outstanding-display">
                <h2>Total Outstanding Amount: {outstandingPayments}</h2>
              </div>
            )}
          </>
        )}
        


  {/************************************************************************************************************************/}      







          {selectedOption === "updatePayments" && (
              <div className="payment-update-container">
              <h1>Update Student Payment</h1>
              <form onSubmit={paymentSubmit}>
                <div className="form-group">
                  <label>Student Registration Number</label>
                  <input
                    type="text"
                    name="registrationNumber"
                    value={formData.registrationNumber}
                    onChange={paymentChange}
                    placeholder="Enter Student Registration Number"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Payment Date</label>
                  <input
                    type="date"
                    name="paymentDate"
                    value={formData.paymentDate}
                    onChange={paymentChange}
                    max={new Date().toISOString().split("T")[0]} // Set the max date to today
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Receipt Number</label>
                  <input
                    type="text"
                    name="receiptNo"
                    value={formData.receiptNo}
                    onChange={paymentChange}
                    placeholder="Enter Receipt Number"
                    maxLength="30"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Payment Type</label>
                  <select  className="admin-panel-select"
                    name="paymentType"
                    value={formData.paymentType}
                    onChange={paymentChange}
                    required
                  >
                    <option value="">Select Payment Type</option>
                    <option value="cash">Cash</option>
                    <option value="Online Transaction">Online Transaction</option>
                    <option value="Bank Deposit">Bank Deposit</option>
                    <option value="cheque">Cheque</option>
                    <option value="card">Card</option>
                    <option value="Scholarship">Scholarship</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Payment Amount</label>
                  <input
                    type="number"
                    name="amount"
                    value={formData.amount}
                    onChange={paymentChange}
                    placeholder="Enter Amount"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Remark</label>
                  <input
                    type="remark"
                    name="remark"
                    value={formData.remark}
                    onChange={paymentChange}
                    placeholder="Remark"
                    required
                  />
                </div>
                <div className="form-buttons">
                  <button type="submit" className="submit-button">
                    Submit
                  </button>
                  <button type="reset" className="cancel-button">
                    Cancel
                  </button>
                </div>
              </form>
              {error && <p style={{ color: "red" }}>{error}</p>}
              {success && <p style={{ color: "green" }}>{success}</p>}
              </div>

            )}





{/************************************************************************************************************************/}      


            {selectedOption === "uploadAssignmentBrief" && (
                  <div className="assignment-form-container">
                    <h1>Upload Assignment Brief</h1>
                    <form onSubmit={uploadAssignmnt}>
                      {/* ID */}
                      <div>
          <label>Select Course</label>
          <select
            className="admin-panel-select"
            value={id}
            onChange={(e) => setId(e.target.value)}
            required
          >
            <option value="">Select Course Type</option>
            <option value="CO">Certificate in Optician</option>
            <option value="DO">Diploma in Optometry</option>
            <option value="HDO">Higher Diploma in Optometry</option>
          </select>
        </div>

                      <div className="form-field">
                      <select
                           className="admin-panel-select"
                          value={batch}
                          onChange={(e) => setBatch(e.target.value)}
                          >
                          <option value="">Select Batch</option>
                          <option value="2023-01">2023-01</option>
                          <option value="2024-01">2024-01</option>
                          <option value="2024-02">2024-02</option>
                          <option value="2025-01">2025-01</option>
                          <option value="2025-02">2025-02</option>
                          <option value="2026-01">2026-01</option>
                          <option value="2026-02">2026-02</option>
                          <option value="2027-01">2027-01</option>
                          <option value="2027-02">2027-02</option>
                          <option value="2028-01">2028-01</option>
                          <option value="2028-02">2028-02</option>
                          <option value="2029-01">2029-01</option>
                          <option value="2029-02">2029-02</option>
                          <option value="2030-01">2030-01</option>
                          <option value="2030-02">2030-02</option>
                          <option value="2031-01">2031-01</option>
                          <option value="2031-02">2031-02</option>
                          <option value="2032-01">2032-01</option>
                          <option value="2032-02">2032-02</option>
                          <option value="2033-01">2033-01</option>
                          <option value="2033-02">2033-02</option>
                          <option value="2034-01">2034-01</option>
                          <option value="2034-02">2034-02</option>
                          <option value="2035-01">2035-01</option>
                          <option value="2035-02">2035-02</option>
                        </select>
                        </div>
                 


              <div>
          <label>Module Name</label>
          <select
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          >
            <option value="">Select Module</option>
            {id === "CO" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Ophthalmic Equipment - Lensometer">Understanding Ophthalmic Equipment - Lensometer</option>
                <option value="Understanding Ophthalmic Equipment - Visual Acuity">Understanding Ophthalmic Equipment - Visual Acuity</option>
                <option value="Understanding Ophthalmic Equipment - Trial Box">Understanding Ophthalmic Equipment - Trial Box</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
              </>
            )}







            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

             {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

          </select>
        </div>


        <div>
                <label htmlFor="moduleCode">Module Code:</label>
          <select
            className="admin-panel-select"
            value={moduleCode}
            onChange={(e) => setModuleCode(e.target.value)}
            required
          >
            <option value="">Select Module Code</option>
            {id === "CO" && (
              <>
                <option value="" disabled>---- CO Modules Code ----</option>
                <option value="CO101">General Science - CO101 </option>
                <option value="CO102">Optics - CO102</option>
                <option value="CO103">Anatomy & Physiology of Eye - CO103</option>
                <option value="CO104">Common Eye Diseases - CO104</option>
                <option value="CO105">Clinical Optics & Refraction - CO105</option>
                <option value="CO201">Understanding Prescription & Ocular Measurement - CO201</option>
                <option value="CO202">Ophthalmic Lens & Frame - CO202</option>
                <option value="CO203">Understanding Equipment - CO203</option>
                <option value="CO204">Sales & Marketing - CO204</option>
              </>
            )}


            {id === "DO" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="-">Information Technology</option>
               <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}

             {id === "HDO" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                               <option value="-">Information Technology</option>
               <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}
          </select>
        </div>



                      <div className="form-field">
                        <label>
                          Issue Date:
                          <input
                            type="date"
                            value={issueDate}
                            onChange={(e) => setIssueDate(e.target.value)}
                            required
                          />
                        </label>
                      </div>

                
                      <div className="form-field">
                        <label>
                          Submission Date:
                          <input
                            type="date"
                            value={submissionDate}
                            onChange={(e) => setSubmissionDate(e.target.value)}
                            required
                          />
                        </label>
                      </div>

                      <div className="form-field">
                        <label>
                          Upload Assignment Brief (PDF):
                          <input
                            type="file"
                            accept="application/pdf"
                            onChange={handleAssignmentChange}
                            required
                          />
                        </label>
                      </div>

                      {/* Progress Bar */}
                      {uploadProgress > 0 && (
                        <div className="progress-bar-container">
                          <div className="progress-bar" style={{ width: `${uploadProgress}%` }}>
                            {Math.round(uploadProgress)}%
                          </div>
                        </div>
                      )}

                      {/* Error Message */}
                      {error && <p className="error-message">{error}</p>}

                      {/* Loading Indicator or Submit Button */}
                      <button type="submit" disabled={loading}>
                        {loading ? "Uploading..." : "Upload Assignment"}
                      </button>
                    </form>

                    {/* Success Message */}
                    {success && <p className="success-message">Assignment uploaded successfully!</p>}
                  </div>
                )}

         

  {/************************************************************************************************************************/}      

        {selectedOption === "uploadResults" && ( 
          <div className="upload-results-container">
            <h1>Upload Results</h1>
            <form onSubmit={uploadResults} className="upload-results-form">
            <select
             className="admin-panel-select"
            value={semester}
            onChange={(e) => setSemester(e.target.value)}
          >
            <option value="">Select Semester</option>
            <option value="Y1S1">Y1 S1</option>
            <option value="Y1S2">Y1 S2</option>
            <option value="Y2S3">Y2 S3</option>
            <option value="Y2S4">Y2 S4</option>
          </select>
          



              <div className="input-group">
                <label htmlFor="date">Exam / Assignment Submitted Date</label>
                <input
                  type="date"
                  id="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  required
                />
              </div>





            <div>
          <label>Attempt No</label>
          <select
            className="admin-panel-select"
            value={attemptNo}
            onChange={(e) => setAttemptNo(e.target.value)}
            required
          >
            <option value="">Select Attempt No</option>
            <option value="1st">1st</option>
            <option value="2nd">2nd</option>
            <option value="3rd">3rd</option>
          </select>
        </div>




          <select
             className="admin-panel-select"
            value={typeOfAssesment}
            onChange={(e) => setTypeOfAssesment(e.target.value)}
          >
            <option value="">Select Type Of Assesment</option>
            <option value="Assignment Result">Assignment Result</option>
            <option value="Continuous Assessment">Continuous Assessment</option>
            <option value="Practical Exam">Practical Exam</option>
            <option value="Final Exam">Final Exam</option>
            {/* <option value="Viva">Viva</option>
            <option value="Practical">Practical</option> */}
          </select>



              <div className="input-group">
                <label htmlFor="registrationNumber">Student Registration No:</label>
                <input
                  type="text"
                  id="registrationNumber"
                  value={registrationNumber}
                  onChange={(e) => setRegistrationNumber(e.target.value)}
                  required
                />
              </div>




            <div>
          <label>Select Course</label>
          <select
            className="admin-panel-select"
            value={program}
            onChange={(e) => setProgram(e.target.value)}
            required
          >
            <option value="">Select Course Type</option>
            <option value="Certificate in Optician">Certificate in Optician</option>
            <option value="Diploma in Optometry">Diploma in Optometry</option>
            <option value="Higher Diploma in Optometry">Higher Diploma in Optometry</option>
          </select>
        </div>


            <select
               className="admin-panel-select"
              value={batch}
              onChange={(e) => setBatch(e.target.value)}
              >
              <option value="">Select Batch</option>
              <option value="2023-01">2023-01</option>
              <option value="2024-01">2024-01</option>
              <option value="2024-02">2024-02</option>
              <option value="2025-01">2025-01</option>
              <option value="2025-02">2025-02</option>
              <option value="2026-01">2026-01</option>
              <option value="2026-02">2026-02</option>
              <option value="2027-01">2027-01</option>
              <option value="2027-02">2027-02</option>
              <option value="2028-01">2028-01</option>
              <option value="2028-02">2028-02</option>
              <option value="2029-01">2029-01</option>
              <option value="2029-02">2029-02</option>
              <option value="2030-01">2030-01</option>
              <option value="2030-02">2030-02</option>
              <option value="2031-01">2031-01</option>
              <option value="2031-02">2031-02</option>
              <option value="2032-01">2032-01</option>
              <option value="2032-02">2032-02</option>
              <option value="2033-01">2033-01</option>
              <option value="2033-02">2033-02</option>
              <option value="2034-01">2034-01</option>
              <option value="2034-02">2034-02</option>
              <option value="2035-01">2035-01</option>
              <option value="2035-02">2035-02</option>
            </select>
            
        <div>
                <label htmlFor="moduleCode">Module Code:</label>
          <select
            className="admin-panel-select"
            value={moduleCode}
            onChange={(e) => setModuleCode(e.target.value)}
            required
          >
            <option value="">Select Module Code</option>
            {program === "Certificate in Optician" && (
              <>
                <option value="" disabled>---- CO Modules Code ----</option>
                <option value="CO101">General Science - CO101 </option>
                <option value="CO102">Optics - CO102</option>
                <option value="CO103">Anatomy & Physiology of Eye - CO103</option>
                <option value="CO104">Common Eye Diseases - CO104</option>
                <option value="CO105">Clinical Optics & Refraction - CO105</option>
                <option value="CO201">Understanding Prescription & Ocular Measurement - CO201</option>
                <option value="CO202">Ophthalmic Lens & Frame - CO202</option>
                <option value="CO203">Understanding Equipment - CO203</option>
                <option value="CO204">Sales & Marketing - CO204</option>
              </>
            )}
            {program === "Diploma in Optometry" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="-">Information Technology</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}

             {program === "Higher Diploma in Optometry" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="-">Information Technology</option>
                <option value="DO101">General Anatomy & Physiology - DO101</option>
                <option value="DO102">General & Ocular Microbiology - DO102</option>
                <option value="DO103">Biochemistry - DO103</option>
                <option value="DO104">Optics- Geometrical& Physical - 	DO104</option>
                <option value="DO105">Ocular anatomy & Physiology - DO105</option>
                <option value="DO106">Pharmacology - DO106</option>
                <option value="DO201">Ocular pathology I - DO201</option>
                <option value="DO202">Clinical procedure I - DO202</option>
                <option value="DO203">Visual optics - DO203</option>
                <option value="DO204">Dispensing Optics - DO204</option>
                <option value="DO205">Physiology of vision - DO205</option>
                <option value="DO206">General Medicine - DO206</option>
                <option value="DO301">Clinical procedure II - DO301</option>
                <option value="DO302">Ocular pathology II - DO302</option>
                <option value="DO303">Binocular Vision - DO303</option>
                <option value="DO304">Contact lens - DO304</option>
                <option value="DO305">Geriatric & Paediatric Optometry - DO305</option>
                <option value="DO306">Low Vision - DO306</option>
                <option value="DO401">Public Health & Community Optometry - DO401</option>
                <option value="DO402">Occupational Optometry - DO402</option>
                <option value="DO403">Practice Management - DO403</option>
                <option value="DO404">Research Methodology & Professional Ethics - DO404</option>
              </>
            )}

          </select>
        </div>

        <div>
          <label>Module Name</label>
          <select
            className="admin-panel-select"
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            required
          >
            <option value="">Select Module</option>
            {program === "Certificate in Optician" && (
              <>
                <option value="" disabled>------ CO Modules ------</option>
                <option value="General Science">General Science</option>
                <option value="Optics">Optics</option>
                <option value="Anatomy & Physiology of Eye">Anatomy & Physiology of Eye</option>
                <option value="Understanding Prescription & Ocular Measurement">Understanding Prescription & Ocular Measurement</option>
                <option value="Ophthalmic Lens & Frame">Ophthalmic Lens & Frame</option>
                <option value="Common Eye Diseases">Common Eye Diseases</option>
                <option value="Clinical Optics & Refraction">Clinical Optics & Refraction</option>
                <option value="Understanding Equipment">Understanding Equipment</option>
                <option value="Sales & Marketing">Sales & Marketing</option>
              </>
            )}
            {program === "Diploma in Optometry" && (
              <>
                <option value="" disabled>------ DO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

             {program === "Higher Diploma in Optometry" && (
              <>
                <option value="" disabled>------ HDO Modules ------</option>
                <option value="Information Technology">Information Technology</option>
                <option value="General Anatomy & Physiology">General Anatomy & Physiology</option>
                <option value="General & Ocular Microbiology">General & Ocular Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Optics- Geometrical & Physical">Optics- Geometrical & Physical</option>
                <option value="Ocular anatomy & Physiology">Ocular anatomy & Physiology</option>
                <option value="Ocular pathology I">Ocular pathology I</option>
                <option value="Clinical procedure I">Clinical procedure I</option>
                <option value="Visual optics">Visual optics</option>
                <option value="Pharmacology">Pharmacology</option>
                <option value="Physiology of vision">Physiology of vision</option>
                <option value="General Medicine">General Medicine</option>
                <option value="Clinical procedure II">Clinical procedure II</option>
                <option value="Ocular pathology II">Ocular pathology II</option>
                <option value="Binocular Vision">Binocular Vision</option>
                <option value="Contact lens">Contact lens</option>
                <option value="Geriatric & Paediatric Optometry">Geriatric & Paediatric Optometry</option>
                <option value="Low Vision">Low Vision</option>
                <option value="Dispensing Optics">Dispensing Optics</option>
                <option value="Public Health & Community Optometry">Public Health & Community Optometry</option>
                <option value="Occupational Optometry">Occupational Optometry</option>
                <option value="Practice Management">Practice Management</option>
                <option value="Research Methodology & Professional Ethics">Research Methodology & Professional Ethics</option>
              </>
            )}

          </select>
        </div>

              <select
               className="admin-panel-select"
              value={grade}
              onChange={(e) => setGrade(e.target.value)}
              >
              <option value="">Select Grade</option>
              <option value="A+">A+</option>
              <option value="A">A</option>
              <option value="B+">B+</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="-">-</option>
              <option value="F">F</option>
              <option value="AB">AB</option>
              <option value="N/A">N/A</option>
            </select>



              <div className="input-group">
                <label htmlFor="remark">Remark:</label>
                <input
                  type="text"
                  id="remark"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  required
                />
              </div>


              <div className="submit-button-container">
                <button type="submit" disabled={loading}>
                  {loading ? "Uploading..." : "Upload Result"}
                </button>
              </div>
            </form>
          </div>
        )}


      </div>
    </div>
  );
};

export default CreateStudentDashboard;
